export default {
  'activity.addPromotionSettings': 'Añadir configuración de promoción',
  'activity.editPromotionSettings': 'Editar configuración de promoción',
  'activity.appIcon': 'Icono de app',
  'activity.back': 'Atrás',
  'activity.basicSettings': 'Configuración básica',
  'activity.batchModify': 'Modificación en lote',
  'activity.batchModifyMaxAmount': 'Modificar lote de devolución diaria máxima',
  'activity.batchModifyRebate': 'Modificar lote de reembolso',
  'activity.batchModifyTicket': 'Modificar lote de ticket de giro',
  'activity.batchModifyTicketCount': 'Modificar lote de cantidad de tickets',
  'activity.cannotDelete': 'No se pueden eliminar datos',
  'activity.cannotDeleteWithBoundTickets': 'Solo eliminar cuando no hay tickets vinculados',
  'activity.clickToUpload': 'Haz clic para cargar',
  'activity.copyPromotion': 'Copiar promoción',
  'activity.currency': 'Moneda',
  'activity.dataLoadFailed': 'Error al cargar datos',
  'activity.deselectAll': 'Deseleccionar todo',
  'activity.displaySort': 'Orden de visualización',
  'activity.editCopy': 'Editar contenido',
  'activity.enterBatchMaxAmount': 'Ingresa el monto máximo de reembolso en lote',
  'activity.enterBatchRebate': 'Ingresa el porcentaje de reembolso en lote',
  'activity.enterBetAmount': 'Ingresa el monto de apuesta (inclusive)',
  'activity.enterDisplaySort': 'Ingresa el orden de visualización',
  'activity.rewardExpireDays': 'Días de vencimiento del premio',
  'activity.enterRewardExpireDays': 'Ingresa días de vencimiento del premio (-1 significa sin vencimiento)',
  'activity.rewardExpireDaysTooltip': 'Ingresa días, -1 significa sin vencimiento',
  'activity.rewardExpireDaysCannotBeZero': 'Los días de vencimiento del premio no pueden ser 0',
  'activity.showFlowMultiple': 'Mostrar cambio de múltiple de flujo',
  'activity.showFlowMultipleOn': 'Activo',
  'activity.showFlowMultipleOff': 'Inactivo',
  'activity.days': 'Días',
  'activity.activityIntroduction': 'Introducción de la actividad',
  'activity.enterActivityIntroduction': 'Ingresa introducción de la actividad',
  'activity.activityIcon': 'Icono de actividad',
  'activity.selectActivityIcon': 'Carga el icono de actividad',
  'activity.detailUrl': 'URL de detalles',
  'activity.enterDetailUrl': 'Ingresa URL de detalles',
  'activity.detailButtonText': 'Texto del botón',
  'activity.enterDetailButtonText': 'Ingresa el texto del botón',
  'activity.enterMaxRebateAmount': 'Ingresa el monto máximo de reembolso',
  'activity.enterPromotionContent': 'Ingresa contenido de la promoción',
  'activity.enterPromotionName': 'Ingresa nombre de la promoción',
  'activity.enterRebatePercent': 'Ingresa porcentaje de reembolso',
  'activity.enterTurnoverMultiple': 'Ingresa múltiple de requisito de apuesta',
  'activity.errorParsingMultiTypeName': 'Error al analizar nombre de tipo múltiple',
  'activity.formValidationFailed': 'Falló validación del formulario',
  'activity.gamePlatform': 'Plataforma de juego',
  'activity.h5Icon': 'Icono H5',
  'activity.language': 'Idioma',
  'activity.loadingTemplate': 'Cargando plantilla de promoción en tiempo real...',
  'activity.manualSend.add': 'Añadir',
  'activity.manualSend.back': 'Atrás',
  'activity.manualSend.batchImport': 'Importar en lote',
  'activity.manualSend.bonusAmount': 'Monto de bono',
  'activity.manualSend.bonusPoints': 'Puntos de bono',
  'activity.manualSend.cash': 'Efectivo',
  'activity.manualSend.point': 'Puntos',
  'activity.manualSend.ticket': 'Ticket de giro',
  'activity.manualSend.confirmIssue': 'Confirmar emisión',
  'activity.manualSend.search': 'Buscar',
  'activity.manualSend.reset': 'Restablecer',
  'activity.manualSend.execute': 'Ejecutar',
  'activity.manualSend.memberAccount': 'Cuenta de miembro',
  'activity.manualSend.enterMemberAccount': 'Ingresa cuenta de miembro',
  'activity.confirmEnable': '¿Está seguro de que desea habilitar esta actividad?',
  'activity.confirmDisable': '¿Está seguro de que desea deshabilitar esta actividad?',
  'activity.manualSend.currency': 'Moneda',
  'activity.manualSend.dataLoadFailed': 'Error al cargar datos',
  'activity.manualSend.downloadTemplate': 'Descargar plantilla',
  'activity.manualSend.enterBonusAmount': 'Ingresa monto de bono',
  'activity.manualSend.enterBonusPoints': 'Ingresa puntos de bono',
  'activity.manualSend.enterMemberName': 'Ingresa nombre de miembro',
  'activity.manualSend.enterTurnoverMultiple': 'Ingresa múltiple de requisito de apuesta',
  'activity.manualSend.failCount': 'Cantidad de fallos',
  'activity.manualSend.importCount': 'Cantidad importada',
  'activity.manualSend.importDetails': 'Detalles de importación',
  'activity.manualSend.importStatus': 'Estado de importación',
  'activity.manualSend.importTime': 'Hora de importación',
  'activity.manualSend.memberName': 'Nombre de miembro',
  'activity.manualSend.operationSuccess': 'Operación exitosa',
  'activity.manualSend.operationTime': 'Hora de operación',
  'activity.manualSend.operator': 'Operador',
  'activity.manualSend.promotionName': 'Nombre de promoción',
  'activity.manualSend.rewardType': 'Tipo de premio',
  'activity.manualSend.selectCurrency': 'Selecciona moneda',
  'activity.manualSend.selectImportStatus': 'Selecciona estado de importación',
  'activity.manualSend.selectPromotionName': 'Selecciona nombre de promoción',
  'activity.manualSend.selectRewardType': 'Selecciona tipo de premio',
  'activity.manualSend.successAmount': 'Monto exitoso',
  'activity.manualSend.successCount': 'Cantidad exitosa',
  'activity.manualSend.turnoverMultiple': 'Múltiple de requisito de apuesta',
  'activity.manualSend.uploadFile': 'Carga archivo CSV o Excel',
  'activity.manualSend.uploadSuccess': 'Añadir exitosamente',
  'activity.manualSend.usageInstructions': 'Instrucciones de uso',
  'activity.manualSend.instruction1': 'Descarga primero la plantilla de importación, importar por lotes de miembros menos de 100k',
  'activity.manualSend.instruction2': 'Para montos que excedan, carga en lotes, máximo una vez cada 5 minutos',
  'activity.manualSend.instruction3': 'El tamaño del documento cargado no debe exceder 20M',
  'activity.manualSend.view': 'Ver',
  'activity.manualSend.selectTicket': 'Selecciona ticket de giro',
  'activity.manualSend.ticketName': 'Nombre de ticket de giro',
  'activity.manualSend.ticketNameLabel': 'Selecciona ticket de giro',
  'activity.manualSend.batchImportSuccess': 'Importación en lote exitosa',
  'activity.manualSend.templateFileName': 'Plantilla de importación de ticket de giro.csv',
  'activity.manualSend.csvColumnMemberName': 'Nombre de miembro',
  'activity.manualSend.csvColumnQuantity': 'Cantidad',
  'activity.manualSend.csvExampleRow': 'Elimina esta fila de ejemplo-{{memberName}},{{quantity}}',
  'activity.manualSend.fileFormat': 'Formato de archivo: formato CSV',
  'activity.manualSend.fileSize': 'Tamaño de archivo: No excede 20MB',
  'activity.manualSend.columnFields': 'Campos de columna: Nombre de miembro,Cantidad',
  'activity.manualSend.totalIssuedQuantity': 'Cantidad total emitida',
  'activity.modifySuccess': 'Modificación exitosa',
  'activity.operationSuccess': 'Operación exitosa',
  'activity.pcIcon': 'Icono de PC',
  'activity.promotionCategory': 'Categoría de promoción',
  'activity.promotionContent': 'Contenido de promoción',
  'activity.promotionEffectiveTime': 'Hora efectiva de promoción',
  'activity.promotionName': 'Nombre de promoción',
  'activity.promotionSettings': 'Configuración de promoción',
  'activity.promotionShowTime': 'Hora de visualización de promoción',
  'activity.promotionTemplate': 'Plantilla de promoción',
  'activity.rebate.awardMax': 'Premio máximo',
  'activity.rebate.betAmount': 'Monto de apuesta (inclusive)',
  'activity.rebate.betAmountMax': 'Monto de apuesta (exclusive)',
  'activity.rebate.betAmountMaxError': 'Monto máximo de apuesta (exclusive) debe ser mayor que monto de apuesta (inclusive)',
  'activity.rebate.cashAmount': 'Monto en efectivo',
  'activity.rebate.cashAwardMethod': 'Método de premio en efectivo',
  'activity.rebate.dailyRecharge': 'Recarga diaria',
  'activity.rebate.desireMultiple': 'Múltiple deseado',
  'activity.rebate.enterAwardMax': 'Ingresa monto máximo de premio',
  'activity.rebate.enterBetAmount': 'Ingresa monto de apuesta (inclusive)',
  'activity.rebate.enterBetAmountMax': 'Ingresa monto de apuesta (exclusive)',
  'activity.rebate.enterCashAmount': 'Ingresa monto en efectivo',
  'activity.rebate.enterDailyRecharge': 'Ingresa monto de recarga diaria',
  'activity.rebate.enterDesireMultiple': 'Ingresa múltiple deseado',
  'activity.rebate.enterPointAmount': 'Ingresa monto en puntos',
  'activity.rebate.fixedAmount': 'Monto fijo',
  'activity.rebate.gamePlatform': 'Plataforma de juego',
  'activity.rebate.percentage': 'Porcentaje',
  'activity.rebate.percentMaxTwoDecimals': 'Proporción debe ser no negativa con máximo 2 decimales',
  'activity.rebate.truncateNotice': 'La proporción de reembolso admite hasta 2 decimales. Los montos de reembolso en efectivo mantienen 2 decimales con el exceso truncado (sin redondeo); premios menores a 0,01 se descartan y no se distribuyen. Reembolsos de puntos no se ven afectados.',
  'activity.rebate.pointAmount': 'Monto en puntos',
  'activity.rebate.pointAwardMethod': 'Método de premio en puntos',
  'activity.rebate.rebateSettings': 'Configuración de reembolso',
  'activity.rebate.selectCashAwardMethod': 'Selecciona método de premio en efectivo',
  'activity.rebate.selectPointAwardMethod': 'Selecciona método de premio en puntos',
  'activity.save': 'Guardar',
  'activity.saving': 'Guardando...',
  'activity.selectAll': 'Seleccionar todo',
  'activity.selectAppIcon': 'Selecciona icono de app',
  'activity.selectCurrency': 'Selecciona moneda',
  'activity.selectCurrencyFirst': 'Selecciona primero la moneda',
  'activity.selectH5Icon': 'Selecciona icono H5',
  'activity.selectLanguage': 'Selecciona idioma',
  'activity.selectPcIcon': 'Selecciona icono de PC',
  'activity.selectPromotionCategory': 'Selecciona categoría de promoción',
  'activity.selectPromotionEffectiveTime': 'Selecciona hora efectiva de promoción',
  'activity.selectPromotionShowTime': 'Selecciona hora de visualización de promoción',
  'activity.selectPromotionTemplate': 'Selecciona plantilla de promoción',
  'activity.selectStatus': 'Selecciona estado',
  'activity.selectTicket': 'Selecciona ticket de giro',
  'activity.enterTicketCount': 'Ingresa cantidad',
  'activity.setMultiLanguage': 'Establecer multiidioma',
  'activity.turnoverMultiple': 'Múltiple de requisito de apuesta',
  'activity.type.action': 'Acción',
  'activity.type.add': 'Añadir',
  'activity.type.addSuccess': 'Añadido exitosamente',
  'activity.type.categoryName': 'Nombre de categoría',
  'activity.type.confirmDelete': '¿Está seguro de que desea eliminar?',
  'activity.type.dataLoadFailed': 'Error al cargar datos',
  'activity.type.delete': 'Eliminar',
  'activity.type.deleteSuccess': 'Eliminado exitosamente',
  'activity.type.edit': 'Editar',
  'activity.type.enterCategoryName': 'Ingresa nombre de categoría',
  'activity.type.enterRemarks': 'Ingresa observaciones',
  'activity.type.enterSort': 'Ingresa orden',
  'activity.type.formValidationFailed': 'Falló validación del formulario',
  'activity.type.language': 'Idioma',
  'activity.type.modifySuccess': 'Modificación exitosa',
  'activity.type.operationTime': 'Hora de operación',
  'activity.type.operator': 'Operador',
  'activity.type.remarks': 'Observaciones',
  'activity.type.selectLanguage': 'Selecciona idioma',
  'activity.type.setMultiLanguage': 'Establecer multiidioma',
  'activity.type.sort': 'Orden',
  'activity.vipLevel': 'VIP{{level}}',
  'activity.welfare.amount': 'Monto de promoción',
  'activity.welfare.cash': 'Efectivo',
  'activity.welfare.claimed': 'Reclamado',
  'activity.welfare.claimMethod': 'Método de reclamación',
  'activity.welfare.createTime': 'Hora de creación',
  'activity.welfare.claimTime': 'Hora de reclamación',
  'activity.welfare.currency': 'Moneda',
  'activity.welfare.dataLoadFailed': 'Error al cargar datos',
  'activity.welfare.enterMemberAccount': 'Ingresa cuenta de miembro',
  'activity.welfare.expireTime': 'Hora de vencimiento del premio',
  'activity.welfare.pointExpireTime': 'Hora de vencimiento de puntos',
  'activity.welfare.memberAccount': 'Cuenta de miembro',
  'activity.welfare.point': 'Puntos',
  'activity.welfare.points': 'Puntos de promoción',
  'activity.welfare.promotionName': 'Nombre de promoción',
  'activity.welfare.rewardName': 'Nombre del premio',
  'activity.welfare.selectCurrency': 'Selecciona moneda',
  'activity.welfare.selectPromotionName': 'Selecciona nombre de promoción',
  'activity.welfare.selectStatus': 'Selecciona estado',
  'activity.welfare.selectSubActivityName': 'Selecciona nombre de subactividad',
  'activity.welfare.vipLevel': 'Nivel VIP',
  'activity.welfare.selectVipLevel': 'Selecciona nivel VIP',
  'activity.welfare.status': 'Estado de promoción',
  'activity.welfare.subActivityName': 'Nombre de subactividad',
  'activity.welfare.systemIssue': 'Emisión del sistema',
  'activity.welfare.status.available': 'Disponible',
  'activity.welfare.status.received': 'Recibido',
  'activity.welfare.status.expired': 'Vencido',
  'activity.welfare.turnoverMultiple': 'Múltiple de requisito de apuesta',
  'activity.welfare.export': 'Exportar',
  'activity.welfare.exportLoading': 'Exportando datos...',
  'activity.welfare.exportSuccess': 'Exportación exitosa',
  'activity.welfare.exportFail': 'Exportación fallida',
  'common.currency': 'Moneda',
  'common.status': 'Estado',
  'activity.selectPromotionName': 'Selecciona nombre de promoción',
  'activity.uploadValidFile': 'Carga y analiza un archivo CSV o Excel válido',
  'export.serialNumber': 'Número de serie',
  'export.fileName': 'Nombre de archivo',
  'export.createDate': 'Fecha de creación',
  'export.status': 'Estado',
  'export.operation': 'Operación',
  'export.status.success': 'Exitoso',
  'export.status.processing': 'Procesando',
  'export.status.failed': 'Descarga fallida',
  'export.button.download': 'Descargar',
  'export.button.delete': 'Eliminar',
  'export.button.refresh': 'Actualizar',
  'export.button.clearAll': 'Limpiar todo',
  'export.downloadList': 'Lista de descargas',
  'export.noData': 'Sin datos',
  'activity.register.cashAmount': 'Monto de premio en efectivo',
  'activity.register.cashAmountMustBeNonNegative': 'El monto de premio en efectivo no puede ser negativo',
  'activity.register.cashAmountTooltip': 'Monto de premio en efectivo recibido al registrarse el usuario, hasta 2 decimales',
  'activity.register.cashRequiresMultiple': 'El múltiple de requisito de apuesta debe establecerse cuando el premio en efectivo es mayor a 0',
  'activity.register.desireMultiple': 'Múltiple de requisito de apuesta',
  'activity.register.desireMultipleTooltip': 'Requisito de múltiple de apuesta para premios en efectivo, debe ser entero',
  'activity.register.enterCashAmount': 'Ingresa monto de premio en efectivo',
  'activity.register.enterDesireMultiple': 'Ingresa múltiple de requisito de apuesta',
  'activity.register.enterPointAmount': 'Ingresa monto de premio en puntos',
  'activity.register.note': 'Notas',
  'activity.register.noteCashDecimal': 'El monto de premio en efectivo puede tener hasta 2 decimales',
  'activity.register.noteCashMultiple': 'El múltiple de requisito de apuesta debe establecerse cuando el premio en efectivo es mayor a 0',
  'activity.register.noteMultipleInteger': 'El múltiple de requisito de apuesta debe ser entero',
  'activity.register.noteOnePerUser': 'Cada usuario solo puede reclamar una vez por actividad',
  'activity.register.notePointInteger': 'El monto de premio en puntos debe ser entero',
  'activity.register.pointAmount': 'Monto de premio en puntos',
  'activity.register.pointAmountMustBeNonNegative': 'El monto de premio en puntos no puede ser negativo',
  'activity.register.pointAmountTooltip': 'Monto de premio en puntos recibido al registrarse el usuario, debe ser entero',
  'activity.register.promotionSettings': 'Configuración de promoción de registro',
  'activity.register.ticketReward': 'Premio de ticket de giro',
  'activity.register.ticket': 'Ticket de giro',
  'activity.register.selectTicketTooltip': 'Selecciona el tipo de ticket de giro a otorgar',
  'activity.register.selectTicketPlaceholder': 'Selecciona ticket de giro',
  'activity.register.ticketCount': 'Cantidad de tickets',
  'activity.register.ticketCountRequired': 'La cantidad debe ingresarse después de seleccionar el ticket',
  'activity.register.ticketCountNonNegative': 'La cantidad no puede ser negativa',
  'activity.register.ticketCountTooltip': 'Establece la cantidad de tickets de giro a otorgar',
  'activity.register.enterTicketCount': 'Ingresa cantidad',
  'activity.register.addTicket': 'Añadir ticket',
  'activity.register.spinTickets': 'Configuración de tickets de giro',
  'activity.register.addSpinTicket': '+ Añadir ticket de giro',
  'activity.register.distributeMode': 'Método de distribución',
  'activity.register.distributeModeDirect': 'Directamente a la cuenta de usuario',
  'activity.register.distributeModeDirectDesc': 'Al primer inicio de sesión, el efectivo se acredita a la cuenta principal, los puntos a la cuenta de puntos, y los giros se otorgan automáticamente',
  'activity.register.distributeModeCoupon': 'Al Centro de promoción (pendiente de reclamación)',
  'activity.register.distributeModeCouponDesc': 'Al primer inicio de sesión, los premios aparecen en el Centro de promoción y se acreditan después de que el usuario los reclama manualmente',
  'activity.register.distributeModeNote': 'Ambos métodos surten efecto en el primer inicio de sesión después del registro, adecuado para escenarios de premios en fases para usuarios importados',
  'activity.register.defaultReward': 'Premio predeterminado',
  'activity.register.defaultRewardDesc': 'Se aplica cuando no se cumple ninguna regla de línea de agente',
  'activity.register.spinCount': 'Cantidad de giros',
  'activity.register.spinTicket': 'Juego de giro',
  'activity.register.spinTicketPlaceholder': 'Giro predeterminado',
  'activity.register.agentLineRules': 'Premios diferentes por línea de agente',
  'activity.register.rule': 'Regla',
  'activity.register.agentLines': 'Líneas de agente aplicables',
  'activity.register.addAgentLine': '+ Añadir línea de agente',
  'activity.register.addAgentLineRule': '+ Añadir regla de línea de agente',
  'activity.register.agentIdDuplicate': 'El mismo agente no puede aparecer en múltiples reglas',
  'activity.register.agentLinesRequired': 'Selecciona al menos una línea de agente',
  'activity.register.onlyTempUser': 'Disponer solo a usuarios de tabla temporal',
  'activity.register.onlyTempUserDesc': 'Cuando se habilita, los premios se distribuyen solo a usuarios registrados en tabla temporal; usuarios de otras fuentes se omiten',

  // Daily First Recharge Template
  'activity.dailyFirstRecharge.title': 'Configuración de primer depósito diario',
  'activity.dailyFirstRecharge.basicSettings': 'Configuración básica',
  'activity.dailyFirstRecharge.cashRewardSettings': 'Configuración de premio en efectivo',
  'activity.dailyFirstRecharge.pointRewardSettings': 'Configuración de premio en puntos',
  'activity.dailyFirstRecharge.rewardLimitSettings': 'Configuración de límite de premios',
  'activity.dailyFirstRecharge.dailyMinRechargeAmount': 'Depósito diario mínimo (inclusive)',
  'activity.dailyFirstRecharge.dailyMaxRechargeAmount': 'Depósito diario máximo (inclusive)',
  'activity.dailyFirstRecharge.cashAwardMethod': 'Método de premio en efectivo',
  'activity.dailyFirstRecharge.cashAmount': 'Monto en efectivo',
  'activity.dailyFirstRecharge.desireMultiple': 'Múltiple de requisito de apuesta',
  'activity.dailyFirstRecharge.pointAwardMethod': 'Método de premio en puntos',
  'activity.dailyFirstRecharge.pointAmount': 'Monto en puntos',
  'activity.dailyFirstRecharge.awardMax': 'Límite máximo de premio',
  'activity.dailyFirstRecharge.enterDailyMinRechargeAmount': 'Ingresa monto de depósito diario mínimo',
  'activity.dailyFirstRecharge.enterDailyMaxRechargeAmount': 'Ingresa monto de depósito diario máximo',
  'activity.dailyFirstRecharge.selectCashAwardMethod': 'Selecciona método de premio en efectivo',
  'activity.dailyFirstRecharge.selectPointAwardMethod': 'Selecciona método de premio en puntos',
  'activity.dailyFirstRecharge.enterCashAmount': 'Ingresa monto en efectivo',
  'activity.dailyFirstRecharge.enterDesireMultiple': 'Ingresa múltiple de requisito de apuesta',
  'activity.dailyFirstRecharge.enterPointAmount': 'Ingresa monto en puntos',
  'activity.dailyFirstRecharge.enterAwardMax': 'Ingresa límite máximo de premio',
  'activity.dailyFirstRecharge.fixedAmount': 'Monto fijo',
  'activity.dailyFirstRecharge.percentage': 'Porcentaje',
  'activity.dailyFirstRecharge.amountMustBeNonNegative': 'El monto no puede ser negativo',
  'activity.dailyFirstRecharge.amountMustBePositive': 'El monto debe ser mayor que 0',
  'activity.dailyFirstRecharge.multipleMustBePositive': 'El múltiple de requisito de apuesta debe ser mayor que 0',
  'activity.dailyFirstRecharge.maxMustBeGreaterThanMin': 'El depósito máximo debe ser mayor que el depósito mínimo',
  'activity.dailyFirstRecharge.dailyMinRechargeAmountTooltip': 'El depósito acumulado diario del usuario debe alcanzar este monto para participar en la actividad',
  'activity.dailyFirstRecharge.dailyMaxRechargeAmountTooltip': 'Límite superior del depósito acumulado diario del usuario, los montos que excedan este límite no participan en el cálculo de la actividad',
  'activity.dailyFirstRecharge.cashAwardMethodTooltip': 'Elige método de cálculo de premio en efectivo: monto fijo o porcentaje basado en depósito',
  'activity.dailyFirstRecharge.cashAmountTooltip': 'Método fijo: monto de premio directo; Método de porcentaje: porcentaje de premio (por ejemplo, 10 significa 10%)',
  'activity.dailyFirstRecharge.desireMultipleTooltip': 'Múltiplo de rollover requerido para obtener premios en efectivo',
  'activity.dailyFirstRecharge.pointAwardMethodTooltip': 'Elegir método de cálculo de recompensa de puntos: cantidad fija o porcentaje basado en depósito',
  'activity.dailyFirstRecharge.pointAmountTooltip': 'Método fijo: cantidad directa de puntos de recompensa; Método porcentaje: porcentaje de recompensa (ej. 5 significa 5%)',
  'activity.dailyFirstRecharge.awardMaxTooltip': 'Límite máximo de monto total de recompensa que los usuarios pueden recibir en una sola actividad',
  'activity.dailyFirstRecharge.note': 'Notas',
  'activity.dailyFirstRecharge.noteAmountRange': 'El depósito mínimo diario debe ser menor que el depósito máximo diario',
  'activity.dailyFirstRecharge.noteAwardMethod': 'Método de recompensa: Fijo = Cantidad/cantidad directa, Porcentaje = Calculado por porcentaje de depósito',
  'activity.dailyFirstRecharge.noteFlowMultiple': 'El múltiplo de flujo se utiliza para requisitos de retiro de recompensas en efectivo',
  'activity.dailyFirstRecharge.noteAwardMax': 'Límite máximo de recompensa es el límite total para premios en efectivo y puntos',
  'activity.dailyFirstRecharge.dailyMinAmount': 'Monto Mínimo Diario',
  'activity.dailyFirstRecharge.dailyMaxAmount': 'Monto Máximo Diario',
  'activity.dailyFirstRecharge.dailyMinAmountTooltip': 'Límite mínimo para monto de depósito diario del miembro',
  'activity.dailyFirstRecharge.dailyMaxAmountTooltip': 'Límite máximo para monto de depósito diario del miembro',
  'activity.dailyFirstRecharge.dailyMaxAmountError': 'El monto máximo diario debe ser mayor que el monto mínimo',
  'activity.dailyFirstRecharge.enterCashPercentage': 'Ingrese porcentaje de recompensa en efectivo',
  'activity.dailyFirstRecharge.enterPointPercentage': 'Ingrese porcentaje de recompensa en puntos',
  'activity.dailyFirstRecharge.percentageMaxError': 'El porcentaje no puede exceder 100%',
  'activity.dailyFirstRecharge.rechargePageDescription': 'Descripción de página de depósito',
  'activity.dailyFirstRecharge.descriptionZhCN': 'Chino simplificado',
  'activity.dailyFirstRecharge.descriptionEnUS': 'Inglés',
  'activity.dailyFirstRecharge.descriptionViVN': 'Vietnamita',
  'activity.dailyFirstRecharge.enterDescription': 'Ingrese descripción',

  // Recharge Bonus Settings
  'activity.recharge.title': 'Configuración de bono de depósito',
  'activity.recharge.rechargeCount': 'Cantidad de depósitos para esta actividad',
  'activity.recharge.minRechargeAmount': 'Depósito mínimo (inclusive)',
  'activity.recharge.maxRechargeAmount': 'Depósito máximo (inclusive)',
  'activity.recharge.cashRewardSettings': "Efectivo",
  'activity.recharge.pointRewardSettings': 'Puntos',
  'activity.recharge.awardMax': 'Límite máximo de recompensa',
  'activity.recharge.addCondition': 'Añadir condición de depósito',
  'activity.recharge.confirmDelete': '¿Confirmar eliminar esta condición?',
  'activity.recharge.enterRechargeCount': 'Ingrese cantidad de depósitos',
  'activity.recharge.enterMinRechargeAmount': 'Ingrese monto mínimo de depósito único',
  'activity.recharge.enterMaxRechargeAmount': 'Ingrese monto máximo de depósito único',
  'activity.recharge.selectCashAwardMethod': 'Seleccione método de recompensa en efectivo',
  'activity.recharge.selectPointAwardMethod': 'Seleccione método de recompensa en puntos',
  'activity.recharge.enterCashAmount': 'Ingrese monto en efectivo',
  'activity.recharge.enterDesireMultiple': 'Ingrese múltiplo de rollover',
  'activity.recharge.enterPointAmount': 'Ingrese cantidad de puntos',
  'activity.recharge.enterAwardMax': 'Ingrese límite máximo de recompensa',
  'activity.recharge.enterCashPercentage': 'Ingrese porcentaje de recompensa en efectivo',
  'activity.recharge.enterPointPercentage': 'Ingrese porcentaje de recompensa en puntos',
  'activity.recharge.fixedAmount': 'Monto fijo',
  'activity.recharge.percentage': 'Porcentaje',
  'activity.recharge.amountMustBePositive': 'El monto debe ser mayor que 0',
  'activity.recharge.rechargeCountMustBePositiveInteger': 'La cantidad de depósitos debe ser un entero positivo',
  'activity.recharge.maxAmountError': 'El monto máximo de depósito debe ser mayor que el monto mínimo',
  'activity.recharge.percentageMaxError': 'El porcentaje no puede exceder 100%',
  'activity.recharge.truncateNotice': 'La ratio de bono admite hasta 2 decimales. Los premios en efectivo basados en porcentaje mantienen 2 decimales con el exceso truncado (sin redondeo); los premios por debajo de 0,01 se descartan y no se distribuyen. Los premios de puntos no se ven afectados.',
  'activity.recharge.cashAwardMethodTooltip': 'Elegir método de cálculo de recompensa en efectivo: monto fijo o porcentaje del depósito',
  'activity.recharge.pointAwardMethodTooltip': 'Elegir método de cálculo de recompensa en puntos: cantidad fija o porcentaje del depósito',
  'activity.recharge.awardMaxTooltip': 'Límite máximo de monto de recompensa que los usuarios pueden recibir en una sola actividad',
  'activity.recharge.rechargeCountMustBeUnique': 'La cantidad de depósitos no puede duplicarse',
  'activity.recharge.rechargeCountMustBeConsecutive': 'La cantidad de depósitos debe ser consecutiva',
  'activity.recharge.cannotBothBeZero': 'La recompensa en efectivo y la recompensa de puntos no pueden ser ambas 0',
  'activity.recharge.stage': 'Fase',
  'activity.recharge.copyStage': 'Copiar fase',
  'activity.recharge.deleteStage': 'Eliminar fase',
  'activity.recharge.enterRechargeCountPlaceholder': 'Ingrese N, ej. 1er, 2do',
  'activity.recharge.awardDistribution': 'Distribución de recompensa',
  'activity.recharge.cashAward': 'Recompensa en efectivo',
  'activity.recharge.selectAwardMethod': 'Seleccione método de recompensa',
  'activity.recharge.enterPercentage': 'Ingrese porcentaje',
  'activity.recharge.enterFixedAmount': 'Ingrese monto fijo',
  'activity.recharge.maxCashAmount': 'Ingrese monto máximo en efectivo (-1 para ilimitado)',
  'activity.recharge.maxAmountValidation': 'Ingrese -1 o un valor mayor o igual a 0',
  'activity.recharge.desireMultiple': 'Ingrese múltiplo de rollover (vacío o 0 para sin límite)',
  'activity.recharge.pointAward': 'Recompensa de puntos',
  'activity.recharge.enterFixedPoints': 'Ingrese puntos fijos',
  'activity.recharge.maxPointAmount': 'Ingrese monto máximo de puntos (-1 para ilimitado)',
  'activity.recharge.lotteryTicket': 'Boleto de lotería',
  'activity.recharge.selectLotteryActivity': 'Seleccione actividad de lotería',
  'activity.recharge.ticketCount': 'Ingrese cantidad (por defecto 1)',
  'activity.recharge.enterTicketCount': 'Ingrese cantidad',
  'activity.recharge.ticketCountNonNegative': 'La cantidad no puede ser negativa',
  'activity.recharge.addStage': '+ Añadir fase',
  // CB7REQ-331 阶段内金额阶梯
  'activity.recharge.tier': 'Nivel',
  'activity.recharge.addTier': '+ Añadir nivel',
  'activity.recharge.deleteTier': 'Eliminar nivel',
  'activity.recharge.tierLast': 'Último nivel · sin límite superior',
  'activity.recharge.tierRangeNoUpper': '≥ {min} (inclusive), sin límite superior',
  'activity.recharge.tierRange': '{min} (inclusive) – {max} (exclusivo)',
  'activity.recharge.tierRangePending': 'Rango pendiente de corrección',
  'activity.recharge.tierMinMustIncrease': 'El mínimo del nivel debe ser estrictamente mayor que el del nivel anterior',
  'activity.recharge.tierListTitle': 'Niveles por importe (según el importe de cada depósito, excluyentes)',
  'activity.recharge.tierListHint': 'Los depósitos por debajo del mínimo del primer nivel no reciben premio · Solo introduzca el "Depósito mínimo (inclusive)" de cada nivel; el límite superior es automáticamente el mínimo del siguiente nivel (exclusivo), el último nivel no tiene límite · Los mínimos deben ser estrictamente crecientes; el backend vuelve a validar al guardar',
  'activity.recharge.tierUpperAuto': 'Límite superior = mínimo del siguiente nivel (exclusivo)',
  'activity.recharge.capOnlyLastTier': 'Los campos de tope solo aparecen en el último nivel (no tiene límite superior, por lo que los premios porcentuales necesitan tope); -1 significa sin límite.',

  // Login Recharge Template
  'activity.loginRecharge.promotionSettings': 'Configuración de sorteo de depósito con login',
  'activity.loginRecharge.awardName': 'Nombre del premio',
  'activity.loginRecharge.pointAmount': 'Cantidad de puntos',
  'activity.loginRecharge.winners': 'Número de ganadores',
  'activity.loginRecharge.type': 'Tipo de premio',
  'activity.loginRecharge.deposit': 'Depósito',
  'activity.loginRecharge.login': 'Login',
  'activity.loginRecharge.addCondition': 'Añadir condición',
  'activity.loginRecharge.atLeastOneCondition': 'Se requiere al menos una condición',
  'activity.loginRecharge.awardNameRequired': 'Se requiere nombre del premio',
  'activity.loginRecharge.pointAmountRequired': 'Se requiere cantidad de puntos',
  'activity.loginRecharge.winnersRequired': 'Se requiere número de ganadores',
  'activity.loginRecharge.enterAwardName': 'Ingrese nombre del premio',
  'activity.loginRecharge.awardNameMaxLength': 'El nombre del premio no puede exceder 100 caracteres',
  'activity.loginRecharge.enterPointAmount': 'Ingrese cantidad de puntos',
  'activity.loginRecharge.pointAmountMustBePositive': 'La cantidad de puntos debe ser mayor que 0',
  'activity.loginRecharge.enterWinners': 'Ingrese número de ganadores',
  'activity.loginRecharge.winnersMustBePositive': 'El número de ganadores debe ser mayor que 0',
  'activity.loginRecharge.selectType': 'Seleccione tipo de premio',
  'activity.loginRecharge.memberAccount': 'Cuenta de miembro',
  'activity.loginRecharge.memberAccountPlaceholder': 'Ingrese cuenta de miembro',

  // Activity Operate Management
  'activity.operate.loginRecharge': 'Sorteo de depósito con login',
  'activity.loginRecharge.triggerAmount': 'Monto desencadenante',
  'activity.loginRecharge.drawDate': 'Fecha de sorteo',
  'activity.loginRecharge.activityName': 'Nombre de actividad',
  'activity.loginRecharge.status': 'Estado',
  'activity.loginRecharge.numberPlate': 'Placa numérica',
  'activity.loginRecharge.awardStatus': 'Estado del premio',
  'activity.loginRecharge.createTime': 'Hora de creación',
  'activity.loginRecharge.pendingDraw': 'Pendiente de sorteo',
  'activity.loginRecharge.drawn': 'Sorteado',
  'activity.loginRecharge.notWin': 'No ganó',
  'activity.loginRecharge.pendingAward': 'Pendiente de premio',
  'activity.loginRecharge.received': 'Recibido',
  'activity.loginRecharge.awardStatusPlaceholder': 'Seleccione estado del premio',
  'activity.loginRecharge.awardAmount': 'Monto del premio',
  'activity.loginRecharge.operator': 'Operador',
  'activity.loginRecharge.operateTime': 'Hora de operación',
  'activity.loginRecharge.updateShareLink': 'Actualizar enlace compartido',
  'activity.loginRecharge.dataPkCode': 'Número de serie del sistema',
  'activity.loginRecharge.shareLink': 'Enlace compartido',
  'activity.loginRecharge.dataPkCodeRequired': 'El número de serie del sistema no puede estar vacío',
  'activity.loginRecharge.shareLinkRequired': 'El enlace compartido no puede estar vacío',
  'activity.loginRecharge.shareLinkPlaceholder': 'Ingrese enlace compartido',
  'activity.loginRecharge.socialMediaLink': 'Enlace de redes sociales',
  'activity.loginRecharge.invalidLink': 'Formato de enlace inválido',
  'activity.loginRecharge.sendAward': 'Enviar premio',
  'activity.loginRecharge.awardSentSuccess': 'Premio enviado exitosamente',
  'activity.loginRecharge.awardSentFail': 'Fallo al enviar premio',
  'activity.loginRecharge.awardSending': 'Enviando premio, por favor espere...',
  'activity.loginRecharge.batchSend': 'Envío por lotes',
  'activity.loginRecharge.batchSendConfirm': 'Confirmar envío por lotes',
  'activity.loginRecharge.batchSendConfirmMessage': '¿Seguro que desea enviar por lotes {{count}} registros seleccionados?\n\nNota: El envío por lotes se procesará de forma asincrónica en segundo plano. Por favor actualice la página más tarde para ver los resultados.',
  'activity.loginRecharge.batchSendConfirmContent': '¿Seguro que desea enviar por lotes {{count}} registros seleccionados?',
  'activity.loginRecharge.batchSendAsyncNotice': 'Nota: El envío por lotes se procesará de forma asincrónica en segundo plano. Por favor actualice la página más tarde para ver los resultados. No envíe repetidamente.',
  'activity.loginRecharge.confirmSend': 'Confirmar envío',
  'activity.loginRecharge.batchSendTaskSubmitted': 'Tarea de envío por lotes enviada, procesando en segundo plano',
  'activity.loginRecharge.batchSendSuccess': 'Tarea de envío por lotes enviada exitosamente',
  'activity.loginRecharge.batchSendFail': 'Fallo al enviar tarea de envío por lotes',
  'activity.loginRecharge.batchSending': 'Enviando tarea de envío por lotes...',
  'activity.loginRecharge.selectRecordsToSend': 'Seleccione registros para enviar',
  'activity.loginRecharge.selectRecordsFirst': 'Por favor seleccione registros para enviar primero',
  'activity.loginRecharge.eligibleRecords': 'Registros elegibles',
  'activity.loginRecharge.selectAllEligible': 'Seleccionar todos los elegibles',

  // Redemption Record Management
  'activity.redemptionRecord.useTime': 'Hora de uso del código de canje',
  'activity.redemptionRecord.manualDistribution': 'Entrega Manual',
  'activity.redemptionRecord.reusable': 'Uso Repetido',
  'activity.redemptionRecord.singleUse': 'Uso Único',
  'activity.redemptionRecord.actNameOrId': 'Nombre/ID de actividad',
  'activity.redemptionRecord.actNameOrIdPlaceholder': 'Ingrese nombre o ID de actividad',
  'activity.redemptionRecord.redemptionCode': 'Código de canje',
  'activity.redemptionRecord.redemptionCodePlaceholder': 'Ingrese código de canje',
  'activity.redemptionRecord.memberAccount': 'Cuenta de miembro',
  'activity.redemptionRecord.memberAccountPlaceholder': 'Ingrese cuenta de miembro',
  'activity.redemptionRecord.promotionName': 'Nombre de promoción',
  'activity.redemptionRecord.usageMode': 'Modo de uso',
  'activity.redemptionRecord.awardContent': 'Contenido del premio',
  'activity.redemptionRecord.distributionMethod': 'Método de distribución',
  'activity.redemptionRecord.redemptionTime': 'Hora de canje',

  // Redemption Code Management
  'activity.redemptionCode.list': 'Lista de códigos de canje',
  'activity.redemptionCode.usageRecord': 'Registro de uso de código de canje',
  'activity.redemptionCode.promotionName': 'Nombre de promoción',
  'activity.redemptionCode.promotionId': 'ID de promoción',
  'activity.redemptionCode.awardAmount': 'Recompensa de canje',
  'activity.redemptionCode.status': 'Estado',
  'activity.redemptionCode.enabled': 'Habilitado',
  'activity.redemptionCode.disabled': 'Deshabilitado',
  'activity.redemptionCode.codeQuantity': 'Cantidad de códigos',
  'activity.redemptionCode.unlimited': 'Ilimitado',
  'activity.redemptionCode.times': 'veces',
  'activity.redemptionCode.usageMode': 'Modo de uso',
  'activity.redemptionCode.reusable': 'Reutilizable',
  'activity.redemptionCode.singleUse': 'Uso único',
  'activity.redemptionCode.unknown': 'Desconocido',
  'activity.redemptionCode.distributionMethod': 'Método de distribución',
  'activity.redemptionCode.manualDistribution': 'Distribución manual',
  'activity.redemptionCode.autoDistribution': 'Distribución automática',
  'activity.redemptionCode.usedCount': 'Cantidad utilizada',
  'activity.redemptionCode.operator': 'Operador',
  'activity.redemptionCode.availableTime': 'Hora disponible',
  'activity.redemptionCode.operation': 'Operación',
  'activity.redemptionCode.quantity': 'Cantidad',
  // Redemption Code Forms and Modals
  'activity.redemptionCode.createSuccess': 'Creado exitosamente',
  'activity.redemptionCode.createFailed': 'Fallo en la creación',
  'activity.redemptionCode.disableSuccess': 'Deshabilitado exitosamente',
  'activity.redemptionCode.enableSuccess': 'Habilitado exitosamente',
  'activity.redemptionCode.confirmDisable': 'Confirmar deshabilitar',
  'activity.redemptionCode.confirmEnable': 'Confirmar habilitar',
  'activity.redemptionCode.couponSettings': 'Configuración de cupón',
  'activity.redemptionCode.promotionNameRequired': 'Ingrese nombre de promoción',
  'activity.redemptionCode.promotionNamePlaceholder': 'Ingrese nombre de promoción',
  'activity.redemptionCode.distributionMethodRequired': 'Seleccione método de distribución',
  'activity.redemptionCode.distributionMethodPlaceholder': 'Seleccione método de distribución',
  'activity.redemptionCode.usageModeRequired': 'Seleccione modo de uso',
  'activity.redemptionCode.usageModePlaceholder': 'Seleccione modo de uso',
  'activity.redemptionCode.availableTimeRequired': 'Seleccione hora disponible',
  'activity.redemptionCode.perUserLimitRequired': 'Ingrese límite por usuario',
  'activity.redemptionCode.perUserLimitPattern': 'Ingrese entero positivo',
  'activity.redemptionCode.perUserLimitPlaceholder': '1 (fijo)',
  'activity.redemptionCode.totalUsagePattern': 'Ingrese -1 (ilimitado) o entero positivo',
  'activity.redemptionCode.totalUsagePlaceholder': '-1 (ilimitado) o entero positivo',
  'activity.redemptionCode.prefixRequired': 'Ingrese prefijo de uso único',
  'activity.redemptionCode.prefixMaxLength': 'Prefijo máximo 4 caracteres',
  'activity.redemptionCode.prefixPattern': 'Solo se permiten letras y números',
  'activity.redemptionCode.prefixPlaceholder': 'ej.: PROM',
  'activity.redemptionCode.awardTypeRequired': 'Seleccione tipo de premio',
  'activity.redemptionCode.awardTypePlaceholder': 'Seleccione tipo de premio',
  'activity.redemptionCode.pointAmountRequired': 'Ingrese cantidad de puntos',
  'activity.redemptionCode.pointAmountPattern': 'Ingrese entero positivo',
  'activity.redemptionCode.pointAmountPlaceholder': 'Cantidad de puntos (entero positivo)',
  'activity.redemptionCode.cashAmountRequired': 'Ingrese monto en efectivo',
  'activity.redemptionCode.cashAmountPattern': 'Ingrese monto válido',
  'activity.redemptionCode.cashAmountPlaceholder': 'Monto en efectivo',
  'activity.redemptionCode.currencyRequired': 'Seleccione moneda',
  'activity.redemptionCode.currencyPlaceholder': 'Seleccione moneda',
  'activity.redemptionCode.turnoverMultipleRequired': 'Ingrese múltiplo de rollover',
  'activity.redemptionCode.turnoverMultiplePlaceholder': 'Múltiplo de rollover',
  // Redemption Code Operations and Modals
  'activity.redemptionCode.addCodes': 'Añadir códigos',
  'activity.redemptionCode.addUsageCount': 'Añadir cantidad de uso',
  'activity.redemptionCode.showUniqueCode': 'Información de código de canje',
  'activity.redemptionCode.exportCodes': 'Exportar códigos',
  'activity.redemptionCode.copySuccess': 'Código de canje copiado al portapapeles',
  'activity.redemptionCode.copyFailed': 'Fallo al copiar',
  'activity.redemptionCode.copyCode': 'Copiar código de canje',
  'activity.redemptionCode.copyInstructions': 'Haga clic en el botón "Copiar código de canje" para copiar el código al portapapeles',
  'activity.redemptionCode.batchNumber': 'Número de lote',
  'activity.redemptionCode.batchQuantity': 'Cantidad',
  'activity.redemptionCode.generationStatus': 'Estado de generación',
  'activity.redemptionCode.generating': 'Generando',
  'activity.redemptionCode.completed': 'Completado',
  'activity.redemptionCode.failed': 'Falló',
  'activity.redemptionCode.batchOperator': 'Operador',
  'activity.redemptionCode.batchCreateTime': 'Hora de creación',
  'activity.redemptionCode.batchOperation': 'Operación',
  'activity.redemptionCode.getBatchListFailed': 'Fallo al obtener lista de lotes',
  'activity.redemptionCode.exportFailed': 'Fallo en la exportación',
  'activity.redemptionCode.availableDate': 'Fecha disponible',
  'activity.redemptionCode.activityName': 'Nombre de actividad',
  'activity.redemptionCode.activityNamePlaceholder': 'Ingrese nombre de actividad',
  'activity.redemptionCode.creator': 'Creador',
  'activity.redemptionCode.creatorPlaceholder': 'Ingrese creador',
  'activity.redemptionCode.statusPlaceholder': 'Seleccione estado',
  // Additional missing translations
  'activity.redemptionCode.points': 'Puntos',
  'activity.redemptionCode.cash': 'Efectivo',
  'activity.redemptionCode.unlimitedTimes': 'Ilimitado',
  'activity.redemptionCode.timesUnit': 'veces',
  'activity.redemptionCode.quantityUnit': 'Cantidad',
  'activity.redemptionCode.dataLoadFailed': 'Fallo al cargar datos',
  'activity.redemptionCode.queryParams': 'Parámetros de consulta',
  'activity.redemptionCode.createRedemptionCodeFailed': 'Fallo al crear código de canje',
  'activity.redemptionCode.startTime': 'Hora de inicio',
  'activity.redemptionCode.endTime': 'Hora de fin',
  'activity.redemptionCode.totalUsageLabel': 'Cantidad total de uso (ingrese -1 para ilimitado)',
  'activity.redemptionCode.prefixLabel': 'Prefijo (máx 4 caracteres, sistema genera 5)',
  'activity.redemptionCode.addCodesSuccess': 'Códigos generados exitosamente',
  'activity.redemptionCode.addCodesFailed': 'Fallo en la generación de códigos',
  'activity.redemptionCode.addUsageCountSuccess': 'Cantidad de uso aumentada exitosamente',
  'activity.redemptionCode.addUsageCountFailed': 'Fallo al aumentar cantidad de uso',
  'activity.redemptionCode.addCodesTitle': 'Añadir códigos',
  'activity.redemptionCode.addUsageCountTitle': 'Añadir cantidad de uso',
  'activity.redemptionCode.redemptionCodeName': 'Nombre del código de canje',
  'activity.redemptionCode.currentTotalUsage': 'Uso total actual',
  'activity.redemptionCode.unlimitedUsage': 'Ilimitado',
  'activity.redemptionCode.addUsageCountRequired': 'Ingrese cantidad de uso a añadir',
  'activity.redemptionCode.addUsageCountRange': 'La cantidad de uso debe estar entre 1-100000',
  'activity.redemptionCode.addUsageCountPlaceholder': 'Ingrese cantidad de uso a añadir',
  'activity.redemptionCode.singleUsePrefix': 'Prefijo de uso único',
  'activity.redemptionCode.addCodesQuantityRequired': 'Ingrese cantidad de códigos a añadir',
  'activity.redemptionCode.addCodesQuantityRange': 'La cantidad de códigos debe estar entre 1-100000',
  'activity.redemptionCode.addCodesQuantityPlaceholder': 'Ingrese cantidad de códigos a añadir',
  'activity.redemptionCode.showUniqueCodeTitle': 'Información de código de canje',
  'activity.redemptionCode.exportCodesTitle': 'Exportar códigos',
  // Common translations
  'common.operation': 'Operación',
  'common.delete': 'Eliminar',
  'common.save': 'Guardar',
  'common.action': 'Acción',
  'common.saveSuccess': 'Guardado exitosamente',
  'common.saveFailed': 'Fallo al guardar',
  'common.confirm': 'Confirmar',
  'common.cancel': 'Cancelar',
  'common.settings': 'Configuración',
  'common.view': 'Ver',
  'common.all': 'Todos',
  // Additional missing translations for forms
  'activity.redemptionCode.codeUnit': 'pzs',
  'activity.redemptionCode.perUserUnit': 'veces',
  'activity.redemptionCode.export': 'Exportar',
  // Button translations
  'common.search': 'Buscar',
  'common.reset': 'Restablecer',
  'common.add': 'Añadir',
  'common.disable': 'Deshabilitar',
  'common.enable': 'Habilitar',
  // Confirmation dialog messages
  'activity.redemptionCode.confirmDisableMessage': '¿Seguro que desea deshabilitar el código de canje "{{actName}}"?',
  'activity.redemptionCode.confirmEnableMessage': '¿Seguro que desea habilitar el código de canje "{{actName}}"?',
  // Show unique code modal
  'activity.redemptionCode.activityNameLabel': 'Nombre de actividad:',
  'activity.redemptionCode.redemptionCodeLabel': 'Código de canje:',
  'activity.redemptionCode.close': 'Cerrar',
  // Add codes modal
  'activity.redemptionCode.uniqueCode': 'Código único',
  'activity.redemptionCode.addUsageCountLabel': 'Añadir cantidad de uso',
  'activity.redemptionCode.addCodesQuantityLabel': 'Nueva cantidad de códigos',
  'activity.redemptionCode.cancel': 'Cancelar',
  'activity.redemptionCode.confirm': 'Confirmar',
  'activity.redemptionCode.reusableModeDescription': '• Modo reutilizable: Aumentar cantidad total de uso del código de canje',
  'activity.redemptionCode.systemUpdateDescription': '• El sistema actualizará el límite total de uso del código de canje',
  'activity.redemptionCode.maxUsageDescription': '• Máximo apoyo de hasta 100,000 usos',
  // Add redemption code modal
  'activity.redemptionCode.availableTimePlaceholder': ['Hora de inicio', 'Hora de fin'],
  'activity.redemptionCode.uniqueCodeRequired': 'Ingrese código único',
  'activity.redemptionCode.uniqueCodeEmpty': 'El código no puede estar vacío',
  'activity.redemptionCode.uniqueCodePlaceholder': 'ej: PROMO2025',
  'activity.redemptionCode.perUserLimit': 'Límite por usuario',
  'activity.redemptionCode.totalUsageLimit': 'Límite total de uso (ingrese -1 para ilimitado)',
  'activity.redemptionCode.totalUsageRequired': 'Ingrese límite total de uso',
  'activity.redemptionCode.singleUsePrefixLabel': 'Prefijo (máx 4 caracteres, sistema genera 5 caracteres)',
  'activity.redemptionCode.singleUsePrefixRequired': 'Ingrese prefijo de uso único',
  'activity.redemptionCode.singleUsePrefixMaxLength': 'Prefijo máximo 4 caracteres',
  'activity.redemptionCode.singleUsePrefixPattern': 'Solo se permiten letras y números',
  'activity.redemptionCode.singleUsePrefixPlaceholder': 'ej: PROM',
  'activity.redemptionCode.awardType': 'Tipo de premio',
  'activity.redemptionCode.pointAmount': 'Cantidad de puntos',
  'activity.redemptionCode.cashAmount': 'Monto en efectivo',
  'activity.redemptionCode.currency': 'Moneda',
  'activity.redemptionCode.turnoverMultiple': 'Múltiplo de rollover',
  'activity.redemptionCode.singleUseDescription': 'Para asegurar que los códigos sean lo suficientemente cortos, el sistema genera solo 5 caracteres, tareas de uso único',
  'activity.redemptionCode.maxCodesDescription': 'Máximo 100,000 códigos',
  // Reward mode (奖励模式)
  'activity.redemptionCode.rewardMode': 'Modo de recompensa',
  'activity.redemptionCode.rewardModeRequired': 'Seleccione modo de recompensa',
  'activity.redemptionCode.rewardModePlaceholder': 'Seleccione modo de recompensa',
  'activity.redemptionCode.fixedMode': 'Fijo',
  'activity.redemptionCode.rangeMode': 'Rango',
  'activity.redemptionCode.randomReward': 'Recompensa aleatoria',
  'activity.redemptionCode.randomPoints': 'Puntos aleatorios',
  'activity.redemptionCode.randomCash': 'Efectivo aleatorio',
  // Range settings (区间设置)
  'activity.redemptionCode.atLeastOneRange': 'Por favor añada al menos un rango',
  'activity.redemptionCode.minAmount': 'Monto mínimo',
  'activity.redemptionCode.minAmountRequired': 'Ingrese monto mínimo',
  'activity.redemptionCode.minAmountMustBeGreaterThanZero': 'El monto mínimo debe ser mayor que 0',
  'activity.redemptionCode.maxAmount': 'Monto máximo',
  'activity.redemptionCode.maxAmountRequired': 'Ingrese monto máximo',
  'activity.redemptionCode.probability': 'Probabilidad (%)',
  'activity.redemptionCode.probabilityRequired': 'Ingrese probabilidad',
  'activity.redemptionCode.probabilityMax100': 'La probabilidad no puede exceder 100%',
  'activity.redemptionCode.positiveIntegerRequired': 'Ingrese un entero positivo',
  'activity.redemptionCode.validNumber': 'Ingrese un número válido',
  'activity.redemptionCode.validNumberMax2Decimal': 'Ingrese un número válido (máximo 2 decimales)',
  'activity.redemptionCode.addRange': 'Añadir',
  'activity.redemptionCode.probabilitySumNote': 'La probabilidad total de todos los rangos debe ser 100%',
  'activity.redemptionCode.probabilityMustBe100': 'La probabilidad total de la configuración de rangos debe ser 100%',
  'activity.redemptionCode.totalRecords': 'Total {{total}} registros',

  // Lucky Spin Template
  'activity.luckySpin.pcIcon': 'Icono de PC',
  'activity.luckySpin.selectPcIcon': 'Seleccione icono de PC',
  'activity.luckySpin.h5Icon': 'Icono H5',
  'activity.luckySpin.selectH5Icon': 'Seleccione icono H5',
  'activity.luckySpin.appIcon': 'Icono de aplicación',
  'activity.luckySpin.selectAppIcon': 'Seleccione icono de aplicación',

  'activity.confirmDelete': '¿Seguro que desea eliminar la actividad?',

  // Custom Template
  'activity.custom.taskType': 'Tipo de tarea',
  'activity.custom.selectVipLevels': 'Seleccione los niveles VIP',
  'activity.custom.selectVipLevel': 'Seleccione el nivel VIP',
  'activity.custom.vipLevels': 'Niveles VIP',
  'activity.custom.vipLevel': 'Nivel VIP',
  'activity.custom.multipleSelect': 'Selección Múltiple',
  'activity.custom.singleSelect': 'Selección Única',
  'activity.custom.vipLevelMode': 'Modo de Selección de Nivel VIP',
  'activity.custom.selectTaskType': 'Seleccione tipo de tarea',
  'activity.custom.once': 'Una vez',
  'activity.custom.repeat': 'Repetir',
  'activity.custom.taskCycle': 'Ciclo de tarea',
  'activity.custom.selectTaskCycle': 'Seleccione ciclo de tarea',
  'activity.custom.daily': 'Diario',
  'activity.custom.weekly': 'Semanal',
  'activity.custom.permanent': 'Permanente',
  'activity.custom.cashRewardDisplay': 'Visualización de recompensa en efectivo',
  'activity.custom.enterCashRewardDisplay': 'Ingrese visualización de recompensa en efectivo',
  'activity.custom.pointRewardDisplay': 'Visualización de recompensa en puntos',
  'activity.custom.enterPointRewardDisplay': 'Ingrese visualización de recompensa en puntos',
  'activity.custom.ticketRewardDisplay': 'Visualización de recompensa de boleto',
  'activity.custom.enterTicketRewardDisplay': 'Ingrese visualización de recompensa de boleto',
  'activity.custom.unlockButtonName': 'Nombre de botón de estado desbloqueado',
  'activity.custom.enterUnlockButtonName': 'Ingrese nombre de botón de estado desbloqueado',
  'activity.custom.buttonJumpLink': 'Enlace de salto de botón',
  'activity.custom.enterButtonJumpLink': 'Ingrese enlace de salto de botón',
  'activity.custom.rewardDisplay': 'Configuración de visualización de recompensa',

  // Every Recharge Template
  'activity.everyRecharge.configTitle': 'Configuración de bono de cada depósito',
  'activity.everyRecharge.minRechargeAmount': 'Depósito mínimo ≥',
  'activity.everyRecharge.maxRechargeAmount': 'Depósito máximo ≤',
  'activity.everyRecharge.awardType': 'Tipo de recompensa',
  'activity.everyRecharge.amount': 'Monto',
  'activity.everyRecharge.turnover': 'Rollover',
  'activity.everyRecharge.settings': 'Configuración',
  'activity.everyRecharge.add': 'Añadir',
  'activity.everyRecharge.addNew': 'Añadir nuevo',
  'activity.everyRecharge.delete': 'Eliminar',
  'activity.everyRecharge.cash': 'Efectivo',
  'activity.everyRecharge.point': 'Puntos',
  'activity.everyRecharge.ticket': 'Boleto',
  'activity.everyRecharge.pleaseSelect': 'Seleccione',
  'activity.everyRecharge.selectAwardType': 'Seleccione tipo de recompensa',
  'activity.everyRecharge.selectTicket': 'Seleccione boleto',
  'activity.everyRecharge.enterMinRechargeAmount': 'Ingrese monto mínimo de depósito',
  'activity.everyRecharge.enterMaxRechargeAmount': 'Ingrese monto máximo de depósito',
  'activity.everyRecharge.enterAmount': 'Ingrese',
  'activity.everyRecharge.enterTurnover': 'Ingrese',
  'activity.everyRecharge.amountMustBePositive': 'El monto debe ser mayor que 0',
  'activity.everyRecharge.turnoverMustBePositive': 'El rollover debe ser mayor o igual a 0',
  'activity.everyRecharge.minMustLessThanMax': 'El mínimo debe ser menor que el máximo',
  'activity.everyRecharge.maxMustGreaterThanMin': 'El máximo debe ser mayor que el mínimo',
  'activity.everyRecharge.rangeOverlap': 'El rango de monto de depósito no puede superponerse con otros niveles',
  'activity.everyRecharge.tierDescription': 'Descripción de página de depósito',
  'activity.everyRecharge.awardSettings': 'Configuración de recompensa',
  'activity.everyRecharge.globalDescription': 'Descripción de bono de depósito',

  // First Deposit Bonus Template
  'activity.firstDeposit.configTitle': 'Configuración de bono de primer depósito',
  'activity.firstDeposit.minRechargeAmount': 'Primer depósito ≥',
  'activity.firstDeposit.maxRechargeAmount': 'Primer depósito ≤',
  'activity.firstDeposit.awardType': 'Tipo de bono',
  'activity.firstDeposit.amount': 'Monto',
  'activity.firstDeposit.turnover': 'Rollover',
  'activity.firstDeposit.addNew': '+ Añadir',
  'activity.firstDeposit.delete': 'Eliminar',
  'activity.firstDeposit.cash': 'Efectivo',
  'activity.firstDeposit.point': 'Puntos',
  'activity.firstDeposit.ticket': 'Boleto',
  'activity.firstDeposit.pleaseSelect': 'Seleccione',
  'activity.firstDeposit.selectAwardType': 'Seleccione tipo de bono',
  'activity.firstDeposit.selectTicket': 'Seleccione boleto',
  'activity.firstDeposit.enterMinRechargeAmount': 'Ingrese monto mínimo de primer depósito',
  'activity.firstDeposit.enterMaxRechargeAmount': 'Ingrese monto máximo de primer depósito',
  'activity.firstDeposit.enterAmount': 'Ingrese',
  'activity.firstDeposit.enterTurnover': 'Ingrese',
  'activity.firstDeposit.amountMustBePositive': 'El monto debe ser mayor que 0',
  'activity.firstDeposit.amountMustBeInteger': 'El monto debe ser un entero',
  'activity.firstDeposit.turnoverMustBePositive': 'El múltiplo de rollover debe ser >= 0',
  'activity.firstDeposit.minMustLessThanMax': 'El mín debe ser menor que el máx',
  'activity.firstDeposit.maxMustGreaterThanMin': 'El máx debe ser mayor que el mín',
  'activity.firstDeposit.awardSettings': 'Configuración de recompensa',
  'activity.firstDeposit.rechargePageDescription': 'Descripción de página de depósito',
  'activity.firstDeposit.enterDescription': 'Ingrese descripción',
  'activity.firstDeposit.distributeMode': 'Modo de distribución',
  'activity.firstDeposit.distributeModeDirect': 'Directo a cuenta de usuario',
  'activity.firstDeposit.distributeModeDirectDesc': 'Después del primer depósito, efectivo acreditado a cuenta principal, puntos a cuenta de puntos, boletos de giros otorgados automáticamente',
  'activity.firstDeposit.distributeModeCoupon': 'Ir a centro de promoción para reclamar',
  'activity.firstDeposit.distributeModeCouponDesc': 'Después del primer depósito, la recompensa aparece en el centro de promoción; el usuario necesita reclamar manualmente',

  // Invite Friends Template
  'activity.invite.inviteRulesAndRewards': 'Reglas de invitación y configuración de recompensas',
  'activity.invite.inviteRulesLogic': 'Lógica: Por cada "amigo válido" generado, el invitador recibe automáticamente la recompensa de invitación; Si "Recompensar invitado simultáneamente" está habilitado, el invitado también recibe automáticamente la recompensa al convertirse en usuario válido (por defecto a cuenta principal).',
  'activity.invite.inviteRulesDetail': 'Efectivo: monto + múltiplo de rollover (rollover requerido = monto reclamado × múltiplo); Puntos: solo monto; Giro afortunado: tipo + cantidad (se permiten múltiples entradas).',
  'activity.invite.taskNameMultiLang': 'Nombre de tarea de recompensa de invitación (multiidioma)',
  'activity.invite.taskNameDescription': 'Se muestra según idiomas seleccionados en información básica:',
  'activity.invite.enterTaskName': 'Ingrese nombre de tarea de recompensa de invitación',
  'activity.invite.inviterReward': 'Recompensa del invitador',
  'activity.invite.inviterRewardDescription': 'Efectivo: monto + múltiplo de rollover (rollover requerido = monto reclamado × múltiplo); Puntos: solo monto; Giro afortunado: tipo + cantidad (se permiten múltiples entradas).',
  'activity.invite.inviteeReward': 'Recompensar invitado simultáneamente',
  'activity.invite.inviteeRewardDescription': 'Cuando está habilitado: Por cada disparo de amigo válido, el invitado recibe automáticamente las recompensas configuradas en esta columna (por defecto a cuenta principal).',
  'activity.invite.amount': 'Monto',
  'activity.invite.turnoverMultiple': 'Múltiplo de rollover',
  'activity.invite.pointsNoTurnover': 'Los puntos no tienen requisito de rollover',
  'activity.invite.selectTicket': 'Seleccione boleto',
  'activity.invite.addTicketReward': 'Añadir recompensa de giro afortunado',
  'activity.invite.achievementReward': 'Recompensa de logro (invitador)',
  'activity.invite.achievementRulesLine1': 'Regla: Las recompensas de logro ya no se dividen por moneda; la moneda se basa en información básica (PHP).',
  'activity.invite.achievementRulesLine2': 'La recompensa de logro "Nombre de recompensa" admite multiidioma: sigue la configuración de idiomas de información básica.',
  'activity.invite.achievementLevel': 'Umbral',
  'activity.invite.rewardIcon': 'Icono de recompensa',
  'activity.invite.threshold': 'Umbral (Amigos válidos ≥)',
  'activity.invite.enterThreshold': 'Ingrese umbral',
  'activity.invite.rewardNameMultiLang': 'Nombre de recompensa (multiidioma)',
  'activity.invite.enterRewardName': 'Ingrese nombre de recompensa de logro',
  'activity.invite.enableCash': 'Habilitar',
  'activity.invite.enablePoint': 'Habilitar',
  'activity.invite.enableTicket': 'Habilitar',
  'activity.invite.addAchievementLevel': 'Añadir umbral de logro',
  'activity.invite.cashTurnoverNote': 'El efectivo requiere rollover = monto en efectivo × múltiplo de rollover; puntos/giro afortunado solo requieren cantidad.',

  'activity.invite.rewardModeFixed': 'Recompensa fija por miembro válido',
  'activity.invite.rewardModeFirstDeposit': 'Recompensa por rango de monto del primer depósito',
  'activity.invite.rewardModeHint': 'Solo un modo está vigente a la vez. El cambio solo aplica a los miembros invitados después del cambio; los miembros ya invitados mantienen el modo y la configuración originales.',
  'activity.invite.inviterRewardLevel1': 'Amigo de nivel 1 (invitador directo)',
  'activity.invite.inviterRewardLevel2': 'Amigo de nivel 2',
  'activity.invite.inviterRewardLevel3': 'Amigo de nivel 3',
  'activity.invite.level1': 'Nivel 1',
  'activity.invite.level2': 'Nivel 2',
  'activity.invite.level3': 'Nivel 3',
  'activity.invite.levelN': 'Nivel {n}',
  'activity.invite.firstDepositIntervalTitle': 'Recompensa por rango de monto del primer depósito',
  'activity.invite.firstDepositRange': 'Rango del primer depósito ({{coin}})',
  'activity.invite.andAbove': 'y superior',
  'activity.invite.addFirstDepositInterval': 'Añadir rango',
  'activity.invite.firstDepositIntervalHint': 'La recompensa se otorga según el rango en el que caiga el monto del primer depósito del amigo; los rangos no deben superponerse ni dejar huecos, el rango más alto no tiene límite superior. Efectivo = monto del primer depósito x la tasa del nivel correspondiente al rango alcanzado, limitado por nivel según el "Monto máximo por persona".',
  'activity.invite.firstDepositCashReward': 'Recompensa en efectivo (Primer depósito x tasa)',
  'activity.invite.firstDepositCap': 'Monto máximo por persona',
  'activity.invite.firstDepositCapHint': 'Límite por nivel, compartido en todos los rangos; monto otorgado = min(primer depósito x tasa, límite de ese nivel). Dejar un nivel en 0 significa que ese nivel no tiene límite.',

  'activity.invite.rebateSetting': 'Configuración de comisión',
  'activity.invite.rebateSettingHint': 'La comisión solo se aplica cuando la actividad está habilitada, dentro de su período de vigencia y este interruptor está activado; si alguna condición no se cumple, se detiene el nuevo cálculo de comisión (las ya emitidas no se ven afectadas). Los cambios aquí solo aplican a los miembros invitados después de la modificación.',
  'activity.invite.rebateEnabled': 'Interruptor general de comisión',
  'activity.invite.rebateLevel': 'Nivel de comisión',
  'activity.invite.autoIssueThreshold': 'Método de emisión',
  'activity.invite.autoIssueThresholdPrefix': 'Automático a la cuenta principal; monto de efectivo único ≥',
  'activity.invite.autoIssueThresholdSuffix': '{{coin}} queda pendiente, confirmar/rechazar en el detalle del cálculo del registro de comisión',
  'activity.invite.rebateMethodDeposit': 'Comisión por depósito',
  'activity.invite.rebateMethodBet': 'Comisión por apuesta',
  'activity.invite.rebateMethodWinLoss': 'Comisión por ganancia/pérdida',
  'activity.invite.rebateMethodHint': 'Elija uno de los cuatro métodos de comisión; solo uno está vigente a la vez. Tras cambiar, todos los miembros pasan al nuevo método desde el siguiente período.',
  'activity.invite.rebateMethodNgr': 'Comisión NGR',
  'activity.invite.ngrRuleHint': 'Liquidación quincenal (1–15 / 16–fin de mes, pago el día siguiente al cierre). NGR del miembro = GGR propio − bonos recibidos (incl. comisión, deducción total) − canje de puntos; comisión del período = Σ NGR de amigos por nivel × ratio del nivel (puede ser negativa y compensarse); a pagar = comisión del período + arrastre anterior; si es negativo no se paga, se arrastra al siguiente período y nunca se descuenta del saldo. Los cambios de ratio/múltiplo/umbral aplican desde la próxima liquidación.',
  'activity.invite.ngrLevelRatio': 'Ratio nivel {{n}}',
  'activity.invite.ngrCashTurnoverMultiple': 'Múltiplo de apuesta del efectivo (0 = retirable)',
  'activity.invite.ngrAutoIssueThreshold': 'Umbral de revisión',
  'activity.invite.ngrAutoIssueThresholdSuffix': '{{coin}} queda pendiente (revisión manual); por debajo del umbral se paga automáticamente',
  'activity.invite.depositThreshold': 'Umbral (depósito total de amigos de nivel 1 de ayer ≥ {{coin}})',
  'activity.invite.betThreshold': 'Umbral (apuesta válida total de amigos de nivel 1 de ayer ≥ {{coin}})',
  'activity.invite.winLossThreshold': 'Umbral (ganancia/pérdida neta total de amigos de nivel 1 de este mes ≥ {{coin}})',
  'activity.invite.betVenueScope': 'Alcance de establecimientos comisionables',
  'activity.invite.rebateTierIndex': 'Nivel',
  'activity.invite.addRebateTier': 'Añadir nivel',
  'activity.invite.rebateTierHint': 'La clasificación se basa en el total acumulado de la base de los amigos de nivel 1 (directos) alcanzando el umbral más alto que cumplan; por debajo del umbral más bajo no hay comisión en este período.',
  'activity.invite.rebateFootnote': 'La base incluye a todos los amigos de nivel 1 a 3 (sin requisito de validez); los amigos de nivel 4 en adelante no se incluyen en ninguna base de recompensa o comisión.',
  'activity.invite.dailyRebateCap': 'Límite diario de comisión (por nivel)',
  'activity.invite.monthlyRebateCap': 'Límite mensual de comisión (por nivel)',
  'activity.invite.rebateCapHint': 'El efectivo de cada nivel = min(base de ese nivel x tasa de ese nivel, límite de ese nivel); lo que supere el límite se limita. Solo aplica a efectivo; puntos/boletos/giros no se ven afectados. Dejar un nivel en 0 significa que ese nivel no tiene límite.',

  'activity.chickActivity.userQuery.title': 'Consulta de estado de usuario',
  'activity.chickActivity.userQuery.userQuery': 'Consulta de usuario',
  'activity.chickActivity.userQuery.userQueryPlaceholder': 'UID / Número de teléfono',
  'activity.chickActivity.userQuery.search': 'Buscar',
  'activity.chickActivity.userQuery.reset': 'Restablecer',
  'activity.chickActivity.userQuery.enterUserQuery': 'Ingrese UID de usuario o número de teléfono',
  'activity.chickActivity.userQuery.userNotFound': 'Usuario no encontrado',
  'activity.chickActivity.userQuery.searchUserFailed': 'Fallo al buscar usuario, intente más tarde',
  'activity.chickActivity.userQuery.queryUserStateFailed': 'Fallo al consultar estado de usuario',
  'activity.chickActivity.userQuery.queryUserStateFailedRetry': 'Fallo al consultar estado de usuario, intente más tarde',
  'activity.chickActivity.userQuery.queryRewardRecordsFailed': 'Fallo al consultar registros de recompensas',
  'activity.chickActivity.userQuery.queryRewardRecordsFailedRetry': 'Fallo al consultar registros de recompensas, intente más tarde',
  'activity.chickActivity.userQuery.stateOverview': 'Descripción general de estado de actividad',
  'activity.chickActivity.userQuery.chickState': 'Estado de incubación',
  'activity.chickActivity.userQuery.energy': 'Energía',
  'activity.chickActivity.userQuery.todayBetCount': 'Cantidad de apuestas válidas de hoy',
  'activity.chickActivity.userQuery.currentPool': 'Piscina actual (si existe)',
  'activity.chickActivity.userQuery.currency': 'Moneda:',
  'activity.chickActivity.userQuery.poolTotal': 'total_piscina:',
  'activity.chickActivity.userQuery.poolRemaining': 'piscina_restante:',
  'activity.chickActivity.userQuery.chestPending': 'Pecho pendiente (por moneda)',
  'activity.chickActivity.userQuery.item': 'Artículo',
  'activity.chickActivity.userQuery.value': 'Valor',
  'activity.chickActivity.userQuery.stateEnumReference': 'Referencia de enumeración de estado: EGG_INCUBATING / EGG_READY / HATCHED_NO_ENERGY / WORKING / HUNGRY / SICK',
  'activity.chickActivity.userQuery.rewardRecords': 'Registros de recompensas y check-in',
  'activity.chickActivity.userQuery.date': 'Fecha',
  'activity.chickActivity.userQuery.time': 'Hora',
  'activity.chickActivity.userQuery.type': 'Tipo',
  'activity.chickActivity.userQuery.reward': 'Recompensa',
  'activity.chickActivity.userQuery.status': 'Estado',
  'activity.chickActivity.userQuery.noData': 'Sin datos',
  'activity.chickActivity.userQuery.rewardType.depositCheckin': 'Check-in de depósito',
  'activity.chickActivity.userQuery.rewardType.freeCheckin': 'Check-in gratuito',
  'activity.chickActivity.userQuery.rewardType.workReward': 'Recompensa de trabajo',
  'activity.chickActivity.userQuery.rewardType.energyCheckin': 'Check-in de energía',
  'activity.chickActivity.userQuery.rewardType.dailyBetMilestone': 'Hito de apuesta - Diario',
  'activity.chickActivity.userQuery.rewardType.weeklyBetMilestone': 'Hito de apuesta - Semanal',
  'activity.chickActivity.userQuery.rewardType.unknown': 'Tipo',
  'activity.chickActivity.userQuery.awardStatus.pending': 'Pendiente',
  'activity.chickActivity.userQuery.awardStatus.claimed': 'Reclamado',
  'activity.chickActivity.userQuery.awardStatus.expired': 'Vencido',
  'activity.chickActivity.userQuery.awardStatus.unknown': 'Desconocido',
  'activity.chickActivity.userQuery.chickState.eggIncubating': 'Incubando',
  'activity.chickActivity.userQuery.chickState.eggReady': 'Listo para eclosionar',
  'activity.chickActivity.userQuery.chickState.hatchedNoEnergy': 'Eclosionado sin energía',
  'activity.chickActivity.userQuery.chickState.working': 'Trabajando',
  'activity.chickActivity.userQuery.chickState.hungry': 'Hambriento',
  'activity.chickActivity.userQuery.chickState.sick': 'Enfermo',
  'activity.chickActivity.userQuery.chickState.idle': 'Inactivo',
  'activity.chickActivity.userQuery.chickState.hatching': 'Eclosionando',
  'activity.chickActivity.userQuery.chickState.almostHatched': 'Casi eclosionado',
  'activity.chickActivity.userQuery.chickState.full': 'Lleno',
  'activity.chickActivity.userQuery.chickState.tired': 'Cansado',
  'activity.chickActivity.userQuery.chickState.exhausted': 'Agotado',
  'activity.chickActivity.userQuery.times': 'veces',
  'activity.chickActivity.userQuery.points': 'puntos',

  'activity.chickActivity.report.title': 'Informe de datos (resumen)',
  'activity.chickActivity.report.dateRange': 'Rango de fechas',
  'activity.chickActivity.report.selectDateRange': 'Seleccione rango de fechas',
  'activity.chickActivity.report.search': 'Buscar',
  'activity.chickActivity.report.reset': 'Restablecer',
  'activity.chickActivity.report.queryDataFailed': 'Fallo al consultar datos',
  'activity.chickActivity.report.queryDataFailedRetry': 'Fallo al consultar informe de datos, intente más tarde',
  'activity.chickActivity.report.statsDescription': 'Descripción de estadísticas (requisitos congelados)',
  'activity.chickActivity.report.participantCountDesc': 'Cantidad de participantes: Cantidad de usuarios únicos que entraron a la página de actividad e hicieron clic en tareas de incubación o reclamaron recompensas ese día (no por cookie).',
  'activity.chickActivity.report.depositUserCountDesc': 'Cantidad de usuarios de depósito de actividad: Cantidad de usuarios únicos que participaron en la actividad e hicieron al menos un depósito ese día.',
  'activity.chickActivity.report.treasureBoxIssuedDesc': 'Caja de tesoro emitida: Monto de recompensa en efectivo escrito en caja de tesoro ese día, contado por moneda (PHP / USDT / VND).',
  'activity.chickActivity.report.treasureBoxClaimedDesc': 'Caja de tesoro reclamada: Monto de recompensa en efectivo reclamado exitosamente de caja de tesoro ese día, contado por moneda.',
  'activity.chickActivity.report.treasureBoxExpiredDesc': 'Caja de tesoro vencida: Monto de recompensa en efectivo vencido y no reclamado ese día, contado por moneda (regla de 24 horas, atribuido por hora de logro).',
  'activity.chickActivity.report.amountPrecision': 'Precisión de monto',
  'activity.chickActivity.report.amountPrecisionDesc': 'Precisión de monto: Efectivo retiene uniformemente 2 decimales, el 3er decimal se trunca directamente. Los puntos se truncan después del punto decimal.',
  'activity.chickActivity.report.date': 'Fecha',
  'activity.chickActivity.report.participantCount': 'Cantidad de participantes',
  'activity.chickActivity.report.depositUserCount': 'Cantidad de usuarios de depósito de actividad',
  'activity.chickActivity.report.depositCheckinClaimCount': 'Cantidad de reclamaciones de check-in de depósito',
  'activity.chickActivity.report.depositCheckinPointsIssued': 'Puntos emitidos de check-in de depósito',
  'activity.chickActivity.report.freeCheckinClaimCount': 'Cantidad de reclamaciones de check-in gratuito',
  'activity.chickActivity.report.freeCheckinPointsIssued': 'Puntos emitidos de check-in gratuito',
  'activity.chickActivity.report.energyCheckinClaimCount': 'Cantidad de reclamaciones de check-in de energía',
  'activity.chickActivity.report.energyCheckinPointsIssued': 'Puntos emitidos de check-in de energía',
  'activity.chickActivity.report.treasureBoxIssued': 'Caja de tesoro emitida',
  'activity.chickActivity.report.treasureBoxClaimed': 'Caja de tesoro reclamada',
  'activity.chickActivity.report.treasureBoxClaimedCount': 'Cantidad de cajas de tesoro reclamadas',
  'activity.chickActivity.report.treasureBoxExpired': 'Caja de tesoro vencida',
  'activity.chickActivity.report.dailyMilestoneIssued': 'Hito emitido (diario)',
  'activity.chickActivity.report.dailyMilestoneClaimed': 'Hito reclamado (diario)',
  'activity.chickActivity.report.dailyMilestoneExpired': 'Hito vencido (diario)',
  'activity.chickActivity.report.weeklyMilestoneIssued': 'Hito emitido (semanal)',
  'activity.chickActivity.report.weeklyMilestoneClaimed': 'Hito reclamado (semanal)',
  'activity.chickActivity.report.weeklyMilestoneExpired': 'Hito vencido (semanal)',

  // New Rebate Template
  'activity.newRebate.title': 'Configuración de rebaja de apuesta nueva',
  'activity.newRebate.firstDepositRebate': 'Rebaja de primer depósito',
  'activity.newRebate.vipRebate': 'Rebaja de apuesta VIP',
  'activity.newRebate.tieredRebate': 'Rebaja de apuesta escalonada',
  'activity.newRebate.firstDepositAmount': 'Monto de primer depósito ≥',
  'activity.newRebate.enterFirstDepositAmount': 'Ingrese monto de primer depósito',
  'activity.newRebate.validDays': 'Días válidos',
  'activity.newRebate.enterValidDays': 'Ingrese días válidos',
  'activity.newRebate.rebateType': 'Tipo de rebaja',
  'activity.newRebate.selectRebateType': 'Seleccione tipo de rebaja',
  'activity.newRebate.cash': 'Efectivo',
  'activity.newRebate.point': 'Puntos',
  'activity.newRebate.rebatePercent': 'Ratio de rebaja',
  'activity.newRebate.enterRebatePercent': 'Ingrese ratio de rebaja',
  'activity.newRebate.truncateNotice': 'La ratio de rebaja admite hasta 2 decimales. Los montos de rebaja mantienen 2 decimales con el exceso truncado (sin redondeo); los premios por debajo de 0,01 se descartan y no se distribuyen. Se aplica a las rebajas en efectivo de rebaja de apuesta de primer depósito / VIP / escalonada; las rebajas en puntos no se ven afectadas.',
  'activity.newRebate.maxRebateCash': 'Rebaja máxima en efectivo diario',
  'activity.newRebate.maxRebatePoint': 'Puntos máximos de rebaja',
  'activity.newRebate.enterMaxRebate': 'Ingrese monto máximo de rebaja',
  'activity.newRebate.turnover': 'Múltiplo de rollover',
  'activity.newRebate.enterTurnover': 'Ingrese rollover',
  'activity.newRebate.vipLevel': 'Nivel VIP',
  'activity.newRebate.selectVipLevel': 'Seleccione nivel VIP',
  'activity.newRebate.bettingTurnover': 'Rollover de apuesta ≥',
  'activity.newRebate.enterBettingTurnover': 'Ingrese rollover de apuesta',
  'activity.newRebate.vipLevelMin': 'Nivel mínimo',
  'activity.newRebate.vipLevelMax': 'Nivel máximo',
  'activity.newRebate.addRule': 'Añadir',
  'activity.newRebate.deleteRule': 'Eliminar',
  'activity.newRebate.gamePlatform': 'Plataforma de juego',
  'activity.newRebate.ruleIndex': 'Regla {{index}}',
  'activity.newRebate.tierIndex': 'Nivel {{index}}',
  'activity.newRebate.atLeastOneRule': 'Se requiere al menos una configuración (efectivo o puntos)',
  'activity.newRebate.maxRuleLimit': 'Solo se permite una configuración de efectivo y una de puntos',
  'activity.newRebate.vipLevelConflict': 'Este nivel VIP ya está siendo utilizado por otra configuración',
  'activity.newRebate.duplicateTurnoverType': 'Una configuración con el mismo tipo de rebaja ya existe para este nivel de rollover',
  'activity.newRebate.atLeastOneGameType': 'Se debe seleccionar al menos un tipo de juego',
  'activity.newRebate.gameType.1': 'Tragamonedas',
  'activity.newRebate.gameType.2': 'Casino en vivo',
  'activity.newRebate.gameType.3': 'Apuestas deportivas',
  'activity.newRebate.gameType.4': 'Lotería',
  'activity.newRebate.gameType.5': 'Pesca',
  'activity.newRebate.gameType.6': 'Cartas y tablero',
  'activity.newRebate.gameType.7': 'Esports',
  'activity.newRebate.gameType.8': 'Minijuegos',
  'activity.newRebate.gameType.9': 'Predicción',
  'activity.newRebate.gameType.10': 'Esports',
  'activity.newRebate.gameType.11': 'Máquina arcade',
  'activity.newRebate.gameType.12': 'Bingo',
  'activity.newRebate.distributeMode': 'Método de distribución',
  'activity.newRebate.distributeModeDirect': 'Distribuir directamente a cuenta de usuario',
  'activity.newRebate.distributeModeDirectDesc': 'En liquidación de rebaja, efectivo acreditado a cuenta principal y puntos acreditados a cuenta de puntos automáticamente',
  'activity.newRebate.distributeModeCoupon': 'Distribuir a centro de promoción para reclamar',
  'activity.newRebate.distributeModeCouponDesc': 'En liquidación de rebaja, la recompensa aparece en el centro de promoción y se acredita después de que el usuario la reclama manualmente',

  'activity.newRebate.gameGroupRebate': 'Rebaja de grupo de juego',
  'activity.newRebate.gameGroup.create': '+ Nuevo grupo de juego',
  'activity.newRebate.gameGroup.createTitle': 'Nuevo grupo de juego',
  'activity.newRebate.gameGroup.syncIcons': 'Sincronizar iconos de juego',
  'activity.newRebate.gameGroup.syncIconsTooltip': 'Obtener langGame.h5Img del idioma predeterminado de la biblioteca de juegos dispset y escribirla en iconUrl para cada juego seleccionable. El iconUrl de daily-stats games[] del front-end se obtiene de esta columna.',
  'activity.newRebate.gameGroup.syncIconsConfirmTitle': '¿Sincronizar iconos para todos los juegos seleccionables?',
  'activity.newRebate.gameGroup.syncIconsConfirmContent': 'Se obtendrá h5Img del idioma predeterminado en lote; solo se escribirán las filas cuyo icono difiera del valor anterior. Generalmente se completa en menos de 5 segundos.',
  'activity.newRebate.gameGroup.syncIconsRunning': 'Sincronizando…',
  'activity.newRebate.gameGroup.syncIconsResultTitle': 'Sincronización completada',
  'activity.newRebate.gameGroup.syncIconsSummary': 'Total {{total}} / Coincidencias {{matched}} / Actualizados {{updated}} / Omitidos {{skipped}}',
  'activity.newRebate.gameGroup.syncIconsSkippedTitle': 'Elementos omitidos (solicitar a ops que completen h5Img en el idioma predeterminado de la biblioteca de juegos)',
  'activity.newRebate.gameGroup.syncIconsSkippedColPlatform': 'Plataforma',
  'activity.newRebate.gameGroup.syncIconsSkippedColGameCode': 'Código de Juego',
  'activity.newRebate.gameGroup.syncIconsSkippedColReason': 'Motivo',
  'activity.newRebate.gameGroup.syncIconsFailed': 'Error en la sincronización, verifique la red o los registros del servidor',
  'activity.newRebate.gameGroup.iconNotSynced': 'Icono no sincronizado. Haga clic en "Sincronizar Iconos de Juego" para completar en lote.',
  'activity.newRebate.gameGroup.iconLoadFailed': 'La URL del icono está sincronizada pero no se cargó (probablemente 404 o ruta incorrecta). Solicite a ops que verifiquen h5Img en la biblioteca de juegos.',
  'activity.newRebate.gameGroup.editTitle': 'Editar Grupo de Juegos',
  'activity.newRebate.gameGroup.basicInfo': 'Información Básica',
  'activity.newRebate.gameGroup.gamesInGroup': 'Juegos en Grupo',
  'activity.newRebate.gameGroup.gamesInGroupHint': 'Un juego solo puede pertenecer a un grupo a la vez; los juegos ocupados aparecen atenuados.',
  'activity.newRebate.gameGroup.name': 'Nombre del Grupo',
  'activity.newRebate.gameGroup.namePlaceholder': 'ej. Spotlight de Juego Nuevo · PG',
  'activity.newRebate.gameGroup.coverImg': 'Portada',
  'activity.newRebate.gameGroup.coverImgPlaceholder': 'Se recomienda 120×120 JPG/PNG, pegue la URL de la imagen',
  'activity.newRebate.gameGroup.coverImgHint': 'Se recomienda 120×120 JPG/PNG/WEBP, máximo 2 MB por imagen',
  'activity.newRebate.gameGroup.startDate': 'Fecha de inicio',
  'activity.newRebate.gameGroup.endDate': 'Fecha de finalización',
  'activity.newRebate.gameGroup.percent': 'Devolución %',
  'activity.newRebate.gameGroup.percentPlaceholder': 'Ingrese devolución %',
  'activity.newRebate.gameGroup.maxRebate': 'Límite Diario',
  'activity.newRebate.gameGroup.maxRebatePlaceholder': 'Ingrese límite diario',
  'activity.newRebate.gameGroup.turnoverMultiplier': 'Volumen de Apuestas ×',
  'activity.newRebate.gameGroup.turnoverMultiplierPlaceholder': 'Ingrese multiplicador de volumen de apuestas',
  'activity.newRebate.gameGroup.timeRange': 'Tiempo Limitado',
  'activity.newRebate.gameGroup.timeRangeHint': 'Opcional; déjelo vacío para permanente. Si se establece, se conecta automáticamente al inicio y se desconecta automáticamente al final.',
  'activity.newRebate.gameGroup.sortNo': 'Ordenar',
  'activity.newRebate.gameGroup.searchGame': 'Buscar nombre del juego…',
  'activity.newRebate.gameGroup.expandAll': 'Expandir Todo',
  'activity.newRebate.gameGroup.collapseAll': 'Contraer Todo',
  'activity.newRebate.gameGroup.selectAllPlatform': 'Seleccionar Todo',
  'activity.newRebate.gameGroup.gamesCount': '{{count}} juegos',
  'activity.newRebate.gameGroup.selectedCount': '{{count}} juegos seleccionados',
  'activity.newRebate.gameGroup.occupied': 'Ocupado',
  'activity.newRebate.gameGroup.atLeastOneGame': 'Seleccione al menos un juego',
  'activity.newRebate.gameGroup.emptySource': 'Sin juegos seleccionables aún. Primero agregue juegos en el Catálogo de Juegos.',
  'activity.newRebate.gameGroup.noMatchedGame': 'Sin juegos coincidentes',
  'activity.newRebate.gameGroup.emptyList': 'Sin grupo de juegos configurado aún',
  'activity.newRebate.gameGroup.listSubtitle': 'El equipo de operaciones puede crear grupos libremente; las apuestas del grupo solo cuentan para este grupo, no para la devolución escalonada.',
  'activity.newRebate.gameGroup.tipDeduct': 'Las apuestas en juegos dentro de cualquier grupo solo cuentan para ese grupo, NO para la devolución escalonada de su tipo de juego (Tragamonedas/En Vivo/Deportes/Pesca).',
  'activity.newRebate.gameGroup.tipUnique': 'Propiedad única: un juego solo puede pertenecer a un grupo a la vez. Los juegos ocupados por otros grupos se marcan como "Ocupado" y se deshabilitan en el modal.',
  'activity.newRebate.gameGroup.tipDeductTitle': 'Atribución de flujo (regla principal)',
  'activity.newRebate.gameGroup.tipDeductDesc': 'Las apuestas en juegos dentro de cualquier grupo solo cuentan para ese grupo, NO para la devolución escalonada de su tipo de juego (Tragamonedas/En Vivo/Deportes/Pesca).',
  'activity.newRebate.gameGroup.tipUniqueTitle': 'Propiedad única',
  'activity.newRebate.gameGroup.tipUniqueDesc': 'Un juego solo puede pertenecer a un grupo a la vez. Los juegos ocupados por otros grupos se marcan como "Ocupado" y se deshabilitan en el modal.',
  'activity.newRebate.gameGroup.noCover': 'Sin Portada',
  'activity.newRebate.gameGroup.longTerm': 'Permanente',
  'activity.newRebate.gameGroup.status': 'Estado',
  'activity.newRebate.gameGroup.statusOf.online': 'En Línea',
  'activity.newRebate.gameGroup.statusOf.upcoming': 'Próximamente',
  'activity.newRebate.gameGroup.statusOf.offline': 'Desconectado',
  'activity.newRebate.gameGroup.statusOf.manualOff': 'Desconectado Manualmente',
  'activity.newRebate.gameGroup.operation': 'Acción',
  'activity.newRebate.gameGroup.edit': 'Editar',
  'activity.newRebate.gameGroup.delete': 'Eliminar',
  'activity.newRebate.gameGroup.unpublish': 'Desapublicar',
  'activity.newRebate.gameGroup.publish': 'Publicar',
  'activity.newRebate.gameGroup.deleteConfirm': '¿Eliminar este grupo de juegos?',
  'activity.newRebate.gameGroup.deleteSuccess': 'Eliminado',
  'activity.newRebate.gameGroup.confirmOk': 'Aceptar',
  'activity.newRebate.gameGroup.cancel': 'Cancelar',
  'activity.newRebate.gameGroup.save': 'Guardar',

  // Info Binding Template translations
  'activity.infoBinding.conditionSettings': 'Configuración de Condiciones',
  'activity.infoBinding.serialNumber': 'Número de Serie',
  'activity.infoBinding.enterSerialNumber': 'Ingrese número de serie',
  'activity.infoBinding.serialNumberMustBePositive': 'El número de serie debe ser mayor que 0',
  'activity.infoBinding.authInfoType': 'Cuando información de autenticación =',
  'activity.infoBinding.selectAuthInfoType': 'Seleccione información de autenticación',
  'activity.infoBinding.authInfo.mobileTask': 'Tarea y Recompensa de Verificación Móvil',
  'activity.infoBinding.authInfo.emailTask': 'Tarea y Recompensa de Verificación de Correo',
  'activity.infoBinding.authInfo.withdrawPasswordTask': 'Tarea y Recompensa de Contraseña de Retiro',
  'activity.infoBinding.authInfo.kycTask': 'Tarea y Recompensa KYC',
  'activity.infoBinding.authInfo.downloadAppTask': 'Tarea y Recompensa de Descarga de APP',
  'activity.infoBinding.authInfo.appLoginMobileVerifiedTask': 'Inicio de Sesión en APP Exitoso y Móvil Verificado',
  'activity.infoBinding.excludeMember.title': 'Lista de Miembros Sin Recompensa',
  'activity.infoBinding.excludeMember.manage': 'Administrar Lista de Exclusión',
  'activity.infoBinding.excludeMember.memberAccount': 'Cuenta de Miembro',
  'activity.infoBinding.excludeMember.createUserName': 'Operador',
  'activity.infoBinding.excludeMember.createTime': 'Hora de Creación',
  'activity.infoBinding.excludeMember.searchPlaceholder': 'Buscar por cuenta',
  'activity.infoBinding.excludeMember.upload': 'Subir CSV',
  'activity.infoBinding.excludeMember.uploadTitle': 'Importación en Lote de Cuentas Excluidas',
  'activity.infoBinding.excludeMember.downloadTemplate': 'Descargar Plantilla',
  'activity.infoBinding.excludeMember.uploadHint': 'Formato CSV: la primera fila es encabezado (memberAccount), las filas subsiguientes son cuentas',
  'activity.infoBinding.excludeMember.deleteSuccess': 'Eliminado correctamente',
  'activity.infoBinding.excludeMember.uploadSuccess': 'Subido correctamente',
  'activity.infoBinding.excludeMember.operation': 'Operación',
  'activity.infoBinding.excludeMember.deleteConfirm': '¿Confirmar eliminar este registro?',
  'activity.infoBinding.excludeMember.confirmOk': 'Confirmar',
  'activity.infoBinding.excludeMember.delete': 'Eliminar',
  'activity.infoBinding.excludeMember.search': 'Buscar',
  'activity.infoBinding.excludeMember.total': 'Total',
  'activity.infoBinding.excludeMember.saveFirst': 'Guarde la actividad primero antes de administrar la lista',
  'activity.infoBinding.rewardDistribution': 'Luego Distribuir',
  'activity.infoBinding.rewardType': 'Tipo de Recompensa',
  'activity.infoBinding.pointAmount': 'Cantidad de Puntos',
  'activity.infoBinding.enterPointAmount': 'Ingrese cantidad de puntos',
  'activity.infoBinding.pointAmountMustBePositive': 'La cantidad de puntos debe ser mayor que 0',
  'activity.infoBinding.addPointReward': 'Añadir Recompensa de Puntos',
  'activity.infoBinding.cashAmount': 'Cantidad en Efectivo',
  'activity.infoBinding.enterCashAmount': 'Ingrese cantidad en efectivo',
  'activity.infoBinding.cashAmountMustBeNonNegative': 'La cantidad en efectivo no puede ser negativa',
  'activity.infoBinding.desireMultiple': 'Multiplicador de Volumen',
  'activity.infoBinding.enterDesireMultiple': 'Ingrese multiplicador de volumen',
  'activity.infoBinding.cashRequiresMultiple': 'El multiplicador de volumen es necesario cuando la recompensa en efectivo es mayor que 0',
  'activity.infoBinding.addCashReward': 'Añadir Recompensa en Efectivo',
  'activity.infoBinding.otherSettings': 'Otras Configuraciones',
  'activity.infoBinding.riskControlConditions': 'Condiciones de Control de Riesgo',
  'activity.infoBinding.selectRiskControlLevel': 'Seleccionar Nivel de Control de Riesgo',
  'activity.infoBinding.taskSwitch': 'Interruptor de Tarea',
  'activity.infoBinding.selectAuthType': 'Seleccionar Tipo de Tarea',
  'activity.infoBinding.selectAuthTypePlaceholder': 'Seleccione tipo de tarea',
  'activity.infoBinding.selectAuthTypeFirst': 'Seleccione tipo de tarea primero',

  // Chick Activity
  'chickActivity.activityConfig': 'Configuración de Actividad',
  'chickActivity.tierRatioModalDesc': 'Si se deja vacío se usa la configuración global; al configurarlo, este nivel usará la proporción personalizada',
  'chickActivity.dataReport': 'Informe de Datos',
  'chickActivity.userQuery': 'Consulta de Estado del Usuario',

  // Activity Configuration Page
  'chickActivity.activityBasic': 'Actividad Básica',
  'chickActivity.activityStatus': 'Estado de la Actividad',
  'chickActivity.enabled': 'Habilitado',
  'chickActivity.disabled': 'Deshabilitado',
  'chickActivity.enabledHint': 'Efectivo para todos los usuarios después de habilitado',
  'chickActivity.activityTime': 'Hora de Actividad',
  'chickActivity.userScope': 'Alcance del Usuario',
  'chickActivity.userScopeDesc': 'Todos los usuarios (crear huevo y participar al iniciar sesión durante el período de actividad)',
  'chickActivity.readonly': 'Solo Lectura',
  'chickActivity.autoHatchTime': 'Tiempo de Eclosión Automática',
  'chickActivity.autoHatchTimeDesc': '72 horas (eclosión automática cuando expira el tiempo, energy=0)',
  'chickActivity.systemDefault': 'Predeterminado del Sistema',
  'chickActivity.systemRules': 'Reglas del Sistema (Solo Lectura)',
  'chickActivity.systemRule1': 'La resistencia total es de 7 espacios; en el día del depósito, se recupera al máximo; si no hay depósito diario, -1.',
  'chickActivity.systemRule2': 'La resistencia 4-7 puede activar devoluciones de trabajo; si la resistencia es 0 (Enfermo), aparece el check-in gratuito.',
  'chickActivity.systemRule3': 'Cada depósito genera un nuevo fondo de reembolso (pool_total recalculado) y las recompensas de trabajo correspondientes se recalculan.',
  'chickActivity.systemRule4': 'Las recompensas del cofre del tesoro son válidas por 24 horas; si no se reclaman, caducan.',
  'chickActivity.systemRule5': 'Criterios de entrada de varios días: si se logra en el día actual pero se escribe en el cofre del tesoro al día siguiente, sigue perteneciendo al día del logro; la validez comienza desde la hora del logro durante 24 horas.',
  'chickActivity.systemRule6': 'Precisión del monto: retener 2 decimales, el tercer dígito se trunca directamente (sin redondeo).',
  'chickActivity.globalRebateRatio': 'Ratio de Reembolso Global',
  'chickActivity.globalRebateRatioExample': 'Ejemplo: Depósito 1000P → pool_total = 8P',
  'chickActivity.workPoolRebateRatio': 'Ratio de Reembolso del Fondo de Trabajo (%)',
  'chickActivity.workPoolRebateRatioDesc': 'Cada Depósito × Este Ratio = pool_total del Nuevo Fondo',
  'chickActivity.poolMaxAmount': 'Cantidad Máxima del Fondo',
  'chickActivity.poolMaxAmountDesc': 'Cantidad máxima del fondo por depósito (limitada si se excede)',
  'chickActivity.workPoolRatio': 'Condición de Desbloqueamiento de Recompensa (Ratio de Apuesta Acumulada)',
  'chickActivity.workPoolRatioExample': 'Activar recompensa de trabajo después de apuesta válida acumulada ≥ Fondo × X%',
  'chickActivity.rewardTurnoverMultiple': 'Multiplicador de Volumen de Efectivo de Recompensa',
  'chickActivity.rewardTurnoverMultipleDesc': 'Requisito de volumen para retiro de recompensa en efectivo (múltiplo)',

  // Hatch Tasks
  'chickActivity.hatchTasks': 'Tareas de Eclosión',
  'chickActivity.taskOnceOnly': 'Cada tarea solo puede completarse una vez',
  'chickActivity.hatchTaskDesc': 'El nombre de la tarea muestra entrada de edición multilingüe; la recompensa es horas para reducir el tiempo de eclosión.',
  'chickActivity.taskNameMultiLang': 'Nombre de la Tarea (Multilingüe)',
  'chickActivity.taskName': 'Nombre de la Tarea',
  'chickActivity.enterTaskName': 'Ingrese nombre de la tarea',
  'chickActivity.taskDesc': 'Descripción de la Tarea',
  'chickActivity.enterTaskDesc': 'Ingrese descripción de la tarea',
  'chickActivity.editTaskName': 'Editar Nombre de la Tarea (Multilingüe)',
  'chickActivity.rewardHours': 'Recompensa (Reducir Tiempo de Eclosión)',
  'chickActivity.directHatch': 'Eclosión Directa (Regla del Sistema)',
  'chickActivity.hours': 'horas',
  'chickActivity.completionCondition': 'Condición de Finalización (Solo Lectura)',
  // Completion condition by taskKey (shared by hatch tasks and energy tasks)
  'chickActivity.taskCondition.bind_phone': 'Complete una vinculación de número de teléfono',
  'chickActivity.taskCondition.bind_email': 'Complete una vinculación de correo electrónico',
  'chickActivity.taskCondition.kyc_verify': 'Complete una verificación KYC',
  'chickActivity.taskCondition.name_chick': 'Nombre al pollito por primera vez',
  'chickActivity.taskCondition.app_login': 'Complete un inicio de sesión en la APP',
  'chickActivity.taskCondition.first_deposit': 'Complete el primer depósito',
  'chickActivity.taskCondition.invite_valid_friend': 'Invite a un amigo válido',

  // Energy Tasks
  'chickActivity.energyTasks': 'Tareas de Energía',
  'chickActivity.energyTaskDesc': 'Configuración de tarea de energía, admite tareas únicas y diarias. La recompensa es valor de energía.',
  'chickActivity.energyTaskType': 'Tipo de Tarea',
  'chickActivity.energyTaskTypeOnce': 'Tarea Única',
  'chickActivity.energyTaskTypeDaily': 'Tarea Diaria',
  'chickActivity.rewardEnergy': 'Energía de Recompensa',
  'chickActivity.energyUnit': 'Energía',
  'chickActivity.rewardPoints': 'Puntos de Recompensa',

  // Deposit Check-in
  'chickActivity.depositCheckin': 'Depósito Check-in (Energía de 7 Días)',
  'chickActivity.currentCurrency': 'Moneda Actual',
  'chickActivity.addTier': 'Añadir Nivel',
  'chickActivity.addWorkTier': 'Añadir Nivel',
  'chickActivity.depositCheckinDesc': 'Recompensa Total = Monto de Depósito × (Ratio de Recompensa de Energía de 7 Días de Nivel) → Dividido por curva D1-D7 (Total=100%).',
  'chickActivity.amountTruncate': 'Truncamiento de monto: mantener 2 decimales, truncar el tercer lugar directamente. El nivel más alto puede configurar "Límite de Puntos" (solo el nivel más alto es efectivo).',
  'chickActivity.depositRange': 'Rango de Depósito',
  'chickActivity.rewardRatio': 'Ratio de Recompensa de Energía de 7 Días (%)',
  'chickActivity.pointCap': 'Límite de Puntos Máximo (Solo Nivel Más Alto)',
  'chickActivity.range': 'Rango',
  'chickActivity.total': 'Total',
  'chickActivity.tierNote': 'Añadir/eliminar niveles afectará sincronizadamente las filas de curva D1-D7; los niveles y curvas de diferentes monedas son independientes.',

  // Free Check-in
  'chickActivity.freeCheckin': 'Check-in Gratuito (Enfermo)',
  'chickActivity.freeCheckinDesc': 'Efecto de deshabilitación: la entrada de check-in gratuito no aparecerá cuando energy=0; no afecta el check-in de depósito y las recompensas de trabajo.',
  'chickActivity.triggerCondition': 'Condición de Activación',
  'chickActivity.sickCondition': 'Energía = 0 (Enfermo)',
  'chickActivity.systemRule': 'Regla del Sistema',
  'chickActivity.dailyLimit': 'Límite Diario',
  'chickActivity.times': 'veces',
  'chickActivity.rewardRange': 'Rango de Recompensa',
  'chickActivity.serverRandom': 'Aleatorio por servidor',
  'chickActivity.readonlyDisplay': 'Pantalla de Solo Lectura',
  'chickActivity.restoreEnergy': 'Restaurar Energía',
  'chickActivity.no': 'No',
  'chickActivity.fixed': 'Fijo',

  // Work Reward
  'chickActivity.workReward': 'Recompensa de Trabajo (Hito)',
  'chickActivity.poolTriggerOnce': 'Activarse una vez por fondo',
  'chickActivity.workRewardDesc': 'Condición de finalización: conteo de apuestas válidas acumuladas diarias ≥ N veces, activarse una vez; otorgar nivel más alto.',
  'chickActivity.workRewardDesc2': 'El conteo de caída por nivel es fijo en 1; recalcular niveles activables después de que cada depósito cree un nuevo fondo.',
  'chickActivity.workRewardDescNew1': 'Cada depósito genera un nuevo fondo de trabajo y comienza a acumular condiciones de desbloqueo de recompensa desde "hora de generación del fondo", luego calcula el conteo de apuestas válidas.',
  'chickActivity.workRewardDescNew2': 'Los hitos son [Escalonados]: al completar cada nivel, se emite la recompensa del nivel (caída predeterminada 1); cada nivel se activa solo una vez.',
  'chickActivity.workRewardDescNew3': 'Después de otro depósito, el fondo se actualiza con el nuevo monto de depósito y el conteo de apuestas se reinicia a 0.',
  'chickActivity.workCondition': 'Condición de Finalización (Acumulada Diariamente ≥ N veces)',
  'chickActivity.accumulateReach': 'Acumulado Alcanzado',
  'chickActivity.dropCount': 'Conteo de Caída',
  'chickActivity.rewardType': 'Tipo de Distribución de Recompensa',
  'chickActivity.cash': 'Efectivo',
  'chickActivity.points': 'Puntos',
  'chickActivity.poolToPointsRatio': 'Ratio de Fondo de Premios a Puntos',
  'chickActivity.cashToPointsRate': 'Puntos por 1 Unidad de Efectivo',
  'chickActivity.useGlobal': 'Usar Global',
  'chickActivity.tierRateModalDesc': 'Dejar vacío para usar configuración global, establecer tasa de cambio personalizada para este nivel',
  'chickActivity.workRewardTotalError': 'El ratio total de Recompensa de Trabajo (Hito) debe ser 100%, actualmente es {total}%',
  'chickActivity.depositCurveTotalError': 'Validación de curva de check-in de depósito fallida:\n{errors}',

  // Jeepney Activity
  'jeepneyActivity.activityStatus': 'Estado de la Actividad',
  'jeepneyActivity.selectActivityStatus': 'Seleccione estado de la actividad',
  'jeepneyActivity.enabled': 'Habilitado',
  'jeepneyActivity.disabled': 'Deshabilitado',
  'jeepneyActivity.currency': 'Moneda',
  'jeepneyActivity.selectCurrency': 'Seleccione moneda',
  'jeepneyActivity.activityTime': 'Hora de Inicio/Finalización de Actividad',
  'jeepneyActivity.selectActivityTime': 'Seleccione hora de inicio/finalización de actividad',
  'jeepneyActivity.rewardExpireDays': 'Días de Caducidad de Recompensa',
  'jeepneyActivity.rewardExpireDaysPlaceholder': 'Ingrese días, -1 significa sin caducidad',
  'jeepneyActivity.enterRewardExpireDays': 'Ingrese días de caducidad de recompensa',
  'jeepneyActivity.days': 'Días',
  'jeepneyActivity.riskControlLevel': 'Nivel de Control de Riesgo',
  'jeepneyActivity.selectRiskControlLevel': 'Seleccionar nivel de control de riesgo',
  'jeepneyActivity.riskControl.restrictLogin': 'Restringir Inicio de Sesión',
  'jeepneyActivity.riskControl.restrictDeposit': 'Restringir Depósito',
  'jeepneyActivity.riskControl.restrictClaim': 'Restringir Optimización de Reclamación',
  'jeepneyActivity.riskControl.suspectedRisk': 'Riesgo Sospechoso',
  'jeepneyActivity.riskControl.sameIpControl': 'Control de IP Misma',
  'jeepneyActivity.multiLanguage': 'Multilingüe',
  'jeepneyActivity.basicSettings': 'Configuración Básica',
  'jeepneyActivity.activityName': 'Nombre de la Actividad',
  'jeepneyActivity.enterActivityName': 'Ingrese nombre de la actividad',
  'jeepneyActivity.promotionName': 'Nombre de la Promoción',
  'jeepneyActivity.detailUrl': 'URL de Detalle',
  'jeepneyActivity.enterDetailUrl': 'Ingrese URL de detalle',
  'jeepneyActivity.activityIntroduction': 'Introducción de Actividad',
  'jeepneyActivity.enterActivityIntroduction': 'Ingrese introducción de actividad',
  'jeepneyActivity.appIcon': 'Icono de APP',
  'jeepneyActivity.selectAppIcon': 'Cargue icono de APP',
  'jeepneyActivity.h5Icon': 'Icono H5',
  'jeepneyActivity.selectH5Icon': 'Cargue icono H5',
  'jeepneyActivity.pcIcon': 'Icono PC',
  'jeepneyActivity.selectPcIcon': 'Cargue icono PC',
  'jeepneyActivity.imageUploadTip': 'Tamaño estándar 700×280 de ancho, admite .jpg .jpeg .png, máximo 2 MB',

  // Track and Reward Settings
  'jeepneyActivity.trackAndRewardSettings': 'Configuración de Seguimiento y Recompensa',
  'jeepneyActivity.basicInfo': 'Información Básica',
  'jeepneyActivity.totalStages': 'Etapas Totales',
  'jeepneyActivity.totalStagesRequired': 'Ingrese etapas totales',
  'jeepneyActivity.totalStagesPlaceholder': 'Ingrese etapas totales',
  'jeepneyActivity.totalStagesTip': 'La última etapa es la etapa final (no es necesario configurar el número de etapa final por separado)',
  'jeepneyActivity.totalStagesTimeLimit': 'Límite de Tiempo de Etapas Totales',
  'jeepneyActivity.sectionEndStages': 'Etapas de Fin de Sección',
  'jeepneyActivity.sectionEndStagesPlaceholder': 'Seleccione etapas de fin de sección',
  'jeepneyActivity.sectionEndStagesTip': 'Las etapas de fin de sección se usan para activar "Recompensa Predeterminada de Fin de Sección" y "Ventana Emergente de Vista Previa de Fin de Sección". Después de la selección manual, las etapas de fin de sección en la tabla se marcarán',
  'jeepneyActivity.cashOutEnabledStages': 'Etapas de Retiro Habilitadas',
  'jeepneyActivity.cashOutEnabledStagesPlaceholder': 'Ingrese etapas de retiro habilitadas',
  'jeepneyActivity.finalStageConsumption': 'Consumo de Etapa Final',
  'jeepneyActivity.finalStageConsumptionPlaceholder': 'Ingrese consumo de etapa final',
  'jeepneyActivity.currencyAcquisitionMethods': 'Métodos de Adquisición de Moneda',
  'jeepneyActivity.currencyAcquisitionMethod': 'Método de Adquisición de Moneda',
  'jeepneyActivity.currencyMethod.invite': 'Combustible de Invitación',
  'jeepneyActivity.currencyMethod.pointsExchange': 'Intercambio de Puntos',
  'jeepneyActivity.currencyMethod.recharge': 'Intercambio de Recarga',
  'jeepneyActivity.stages': 'Etapas',
  'jeepneyActivity.exchangeRatio': 'Ratio de Intercambio',
  'jeepneyActivity.minRechargeAmount': 'Monto de Recarga ≥',
  'jeepneyActivity.rewardValueType': 'Método de Valor',
  'jeepneyActivity.rewardValueTypeRequired': 'Seleccione método de valor',
  'jeepneyActivity.rewardValueType.fixed': 'Distribución Fija',
  'jeepneyActivity.rewardValueType.random': 'Distribución Aleatoria',
  'jeepneyActivity.value': 'Valor',
  'jeepneyActivity.currencyName': 'Nombre de la Moneda',
  'jeepneyActivity.currencyNameRequired': 'Ingrese nombre de la moneda',
  'jeepneyActivity.currencyNamePlaceholder': 'Ingrese nombre de la moneda',
  'jeepneyActivity.buttonName': 'Nombre del Botón',
  'jeepneyActivity.buttonNameRequired': 'Ingrese nombre del botón',
  'jeepneyActivity.buttonNamePlaceholder': 'Ingrese nombre del botón',
  'jeepneyActivity.singleRoundCashCap': 'Límite de Efectivo de Ronda Única',
  'jeepneyActivity.currencyRequired': 'Seleccione moneda',
  'jeepneyActivity.amountRequired': 'Ingrese monto',
  'jeepneyActivity.amount': 'Monto',
  'jeepneyActivity.stageConfig': 'Configuración de Etapa',
  'jeepneyActivity.stageNumber': 'Número de Etapa',
  'jeepneyActivity.stageType': 'Tipo de Etapa',
  'jeepneyActivity.stageType.normal': 'Normal',
  'jeepneyActivity.stageType.sectionEnd': 'Fin de Sección',
  'jeepneyActivity.stageType.final': 'Final',
  'jeepneyActivity.configSource': 'Fuente de Recompensa',
  'jeepneyActivity.configSource.default': 'Configuración Predeterminada',
  'jeepneyActivity.configSource.manual': 'Configuración Manual',
  'jeepneyActivity.rewardType': 'Tipo de Recompensa',
  'jeepneyActivity.rewardType.fixed': 'Fijo',
  'jeepneyActivity.rewardType.random': 'Aleatorio',
  'jeepneyActivity.rewardContent': 'Contenido de Recompensa',
  'jeepneyActivity.notConfigured': 'No Configurado',
  'jeepneyActivity.accumulatedConsumption': 'Consumo Acumulado',
  'jeepneyActivity.actualConsumption': 'Consumo Real (Diferencia)',
  'jeepneyActivity.distributionMethod': 'Método de Distribución',
  'jeepneyActivity.distributionMethod.all': 'Distribuir Todas las Recompensas',
  'jeepneyActivity.distributionMethod.randomOne': 'Distribuir Aleatoriamente Una Recompensa',
  'jeepneyActivity.cashOutEnabled': 'Canjear la recompensa de este nivel',
  'jeepneyActivity.defaultRewardSettings': 'Configuración de Etapa Predeterminada',
  'jeepneyActivity.singleRoundPointsCap': 'Límite de Puntos por Ronda',
  'jeepneyActivity.singleRoundPointsCapRequired': 'Por favor, ingrese el límite de puntos por ronda',
  'jeepneyActivity.singleRoundPointsCapPlaceholder': 'Por favor, ingrese el límite de puntos por ronda',
  'jeepneyActivity.singleRoundVoucherCap': 'Límite de Cupón Único por Ronda',
  'jeepneyActivity.singleRoundVoucherCapRequired': 'Por favor, ingrese el límite de cupón único por ronda',
  'jeepneyActivity.singleRoundVoucherCapPlaceholder': 'Por favor, ingrese el límite de cupón único por ronda',
  'jeepneyActivity.singleRoundFuelCap': 'Límite de Combustible por Ronda',
  'jeepneyActivity.singleRoundFuelCapRequired': 'Por favor, ingrese el límite de combustible por ronda',
  'jeepneyActivity.singleRoundFuelCapPlaceholder': 'Por favor, ingrese el límite de combustible por ronda',
  'jeepneyActivity.sectionEndStagesRequired': 'Por favor, seleccione etapas de fin de sección',
  'jeepneyActivity.minimumParticipationThreshold': 'Umbral de Participación Mínima',
  'jeepneyActivity.minimumParticipationThresholdRequired': 'Por favor, ingrese el umbral de participación mínima',
  'jeepneyActivity.minimumParticipationThresholdPlaceholder': 'Por favor, ingrese el umbral de participación mínima',
  'jeepneyActivity.globalCashTurnoverMultiplier': 'Multiplicador de Rotación de Efectivo Global',
  'jeepneyActivity.globalCashTurnoverMultiplierRequired': 'Por favor, ingrese el multiplicador de rotación de efectivo global',
  'jeepneyActivity.globalCashTurnoverMultiplierPlaceholder': 'Por favor, ingrese el multiplicador de rotación de efectivo global',
  'jeepneyActivity.countdownSettings': 'Configuración de Cuenta Regresiva',
  'jeepneyActivity.countdownRuleTip': 'Dentro de la cuenta regresiva aumentada de tiempo limitado, si no se completan tareas cronometradas, la próxima ronda se reiniciará.',
  'jeepneyActivity.timedTaskCountdown': 'Cuenta Regresiva de Tarea Cronometrada',
  'jeepneyActivity.duration': 'Duración',
  'jeepneyActivity.durationRequired': 'Por favor, ingrese la duración de la cuenta regresiva',
  'jeepneyActivity.hours': 'Horas',
  'jeepneyActivity.minutes': 'Minutos',
  'jeepneyActivity.seconds': 'Segundos',
  'jeepneyActivity.allowAllCompletion': 'Permitir Completación de Todo',
  'jeepneyActivity.allowAllCompletionTip': 'Si se desactiva, completar una tarea hará que esta entrada de tarea desaparezca; al final de la próxima cuenta regresiva, se mostrarán tareas completamente nuevas.',
  'jeepneyActivity.rechargeTasks': 'Tareas de Recarga',
  'jeepneyActivity.rechargeAmount': 'Cantidad de Recarga ≥',
  'jeepneyActivity.timeIncrease': 'Aumento de Cuenta Regresiva',
  'jeepneyActivity.timeIncreaseRequired': 'Por favor, ingrese el aumento de cuenta regresiva',
  'jeepneyActivity.inviteTasks': 'Tareas de Invitación',
  'jeepneyActivity.inviteFriends': 'Invitar Amigos',
  'jeepneyActivity.inviteFriendType': 'Tipo de Amigo a Invitar',
  'jeepneyActivity.inviteValidFriends': 'Amigos Válidos',
  'jeepneyActivity.inviteRegisteredFriends': 'Amigos Registrados',
  'jeepneyActivity.registeredUsers': 'Usuarios Registrados',
  'jeepneyActivity.peopleCount': 'Recuento de Personas',
  'jeepneyActivity.peopleCountRequired': 'Por favor, ingrese el recuento de personas',
  'jeepneyActivity.rewardValuePerInstance': 'Valor de Recompensa por Instancia',
  'jeepneyActivity.rewardValue': 'Valor de Recompensa',
  'jeepneyActivity.pointsExchange': 'Intercambio de Puntos',
  'jeepneyActivity.consumePoints': 'Consumir Puntos',
  'jeepneyActivity.consumePointsRequired': 'Por favor, ingrese puntos a consumir',
  'jeepneyActivity.dailyPurchaseLimit': 'Límite de Compra Diaria',
  'jeepneyActivity.dailyPurchaseLimitRequired': 'Por favor, ingrese el límite de compra diaria',
  'jeepneyActivity.testRechargeCount': 'Recuento de Recarga de Prueba',
  'jeepneyActivity.testInviteCount': 'Recuento de Invitación de Prueba',
  'jeepneyActivity.unit': 'Unidad',
  'jeepneyActivity.unitRequired': 'Por favor, seleccione la unidad',
  'jeepneyActivity.validFriends': 'Invitar Amigos Válidos',
  'jeepneyActivity.validFriendsRequired': 'Por favor, ingrese el número de amigos válidos',
  'jeepneyActivity.countdownConfigTip': 'Al configurar operaciones, evite establecer múltiples umbrales similares para evitar una experiencia confusa (se recomienda que los umbrales sean claros y las diferencias de tiempo sean distintas).',
  'jeepneyActivity.fuelConsumptionWarning': 'Las modificaciones en la tabla actualizarán todos los valores de consumo acumulado posterior basados en el valor ingresado de la etapa actual, y recalcularán el consumo real',
  'jeepneyActivity.pleaseSetTotalStages': 'Por favor, establezca el total de etapas primero',
  'jeepneyActivity.defaultRewardConfig': 'Configuración de Etapa Predeterminada',
  'jeepneyActivity.entryReward': 'Recompensa de Entrada',
  'jeepneyActivity.entryRewardApplied': 'Contenido de Recompensa de Entrada Aplicado',
  'jeepneyActivity.notSet': 'No Establecido',
  'jeepneyActivity.defaultReward': 'Configuración de Etapa',
  'jeepneyActivity.rewardConfig': 'Configuración de Recompensa',
  'jeepneyActivity.rewardTypeDuplicate.points': 'Los puntos pueden aparecer solo una vez',
  'jeepneyActivity.rewardTypeDuplicate.fuel': 'El combustible puede aparecer solo una vez',
  'jeepneyActivity.cashCurrencyDuplicate': 'El efectivo con la misma moneda puede aparecer solo una vez',
  'jeepneyActivity.ticketTypeDuplicate': 'El carrusel del mismo tipo puede aparecer solo una vez',
  'jeepneyActivity.rewardTypeRequired': 'Por favor, seleccione el tipo de recompensa',
  'jeepneyActivity.rewardType.cash': 'Efectivo',
  'jeepneyActivity.rewardType.points': 'Puntos',
  'jeepneyActivity.rewardType.spinTicket': 'Boleto de Giro',
  'jeepneyActivity.rewardType.fuel': 'Combustible',
  'jeepneyActivity.rewardType.none': 'Ninguno',
  'jeepneyActivity.turntableType': 'Tipo de Carrusel',
  'jeepneyActivity.turntableTypeRequired': 'Por favor, seleccione el tipo de carrusel',
  'jeepneyActivity.turntable1': 'Carrusel 1',
  'jeepneyActivity.turntable2': 'Carrusel 2',
  'jeepneyActivity.valueRequired': 'Por favor, ingrese el valor',
  'jeepneyActivity.minValue': 'Valor Mínimo',
  'jeepneyActivity.minValueRequired': 'Por favor, ingrese el valor mínimo',
  'jeepneyActivity.maxValue': 'Valor Máximo',
  'jeepneyActivity.maxValueRequired': 'Por favor, ingrese el valor máximo',
  'jeepneyActivity.defaultRewardWarning': 'Nota: El botón de avance rápido del cliente debe avanzar 1 nivel, para evitar hacer clic sin movimiento, si no se configura, el juego no se puede jugar',
  'jeepneyActivity.currencyConsumptionStrategy': 'Estrategia de Consumo de Moneda',
  'jeepneyActivity.rewardDistributionStrategy': 'Estrategia de Distribución de Recompensa',
  'jeepneyActivity.startingConsumption': 'Consumo Inicial',
  'jeepneyActivity.startingConsumptionRequired': 'Por favor, ingrese el consumo inicial',
  'jeepneyActivity.incrementalStep': 'Paso Incremental',
  'jeepneyActivity.incrementalStepRequired': 'Por favor, ingrese el paso incremental',
  'jeepneyActivity.randomDistributionFormulaGeneration': 'Generar Fórmula de Distribución Aleatoria',
  'jeepneyActivity.rewardProgressionPerStage': 'Progresión de Recompensa por Etapa',
  'jeepneyActivity.stagesPerIncrease': 'Cada N Etapas',
  'jeepneyActivity.stagesPerIncreaseRequired': 'Por favor, ingrese cada N etapas',
  'jeepneyActivity.stagesPerIncreaseMin': 'Debe ser mayor que 0',
  'jeepneyActivity.minValueIncrease': 'Aumento de Valor Mínimo',
  'jeepneyActivity.minValueIncreaseRequired': 'Por favor, ingrese el aumento de valor mínimo',
  'jeepneyActivity.maxValueIncrease': 'Aumento de Valor Máximo',
  'jeepneyActivity.maxValueIncreaseRequired': 'Por favor, ingrese el aumento de valor máximo',
  'jeepneyActivity.rewardProgressionHint': 'Sugerencia: El valor mínimo no debe exceder el valor máximo; cuanto más amplio sea el rango, más fuerte será la sensación de aleatoriedad.',
  'jeepneyActivity.tailStageMultiplierValue': 'Valor de Multiplicador de Etapa Final',
  'jeepneyActivity.tailStageMultiplier': 'Multiplicador de Etapa Final',
  'jeepneyActivity.sectionEndMultiplier': 'Multiplicador de Fin de Sección',
  'jeepneyActivity.tailRewardMultiplier': 'Recompensa Final x',
  'jeepneyActivity.tailStageMultiplierDesc': 'Las etapas finales multiplican el contenido de recompensa por el valor establecido',
  'jeepneyActivity.tailStageMultiplierTip': 'Las etapas finales multiplican el contenido de recompensa por el valor establecido',
  'jeepneyActivity.sectionEndMultiplierTip': 'Las etapas finales multiplican el contenido de recompensa por el valor establecido',
  'jeepneyActivity.finalStageMultiplierValue': 'Valor de Multiplicador de Etapa Final',
  'jeepneyActivity.finalMultiplier': 'Multiplicador Final',
  'jeepneyActivity.finalStageMultiplier': 'Multiplicador de Etapa Final',
  'jeepneyActivity.finalRewardMultiplier': 'Recompensa Final x',
  'jeepneyActivity.finalStageMultiplierDesc': 'La etapa final multiplica el contenido de recompensa por el valor establecido',
  'jeepneyActivity.finalMultiplierTip': 'La etapa final multiplica el contenido de recompensa por el valor establecido',
  'jeepneyActivity.safetyUpperLimit': 'Límite de Seguridad Superior (Valor máximo no excedido)',
  'jeepneyActivity.safetyUpperLimitRequired': 'Por favor, ingrese el límite de seguridad superior',
  'jeepneyActivity.safetyUpperLimitDesc': 'Explicación: El resultado generado se limitará a no exceder el límite superior. Ingrese 0 para deshabilitar el límite superior.',
  'jeepneyActivity.safetyCap': 'Límite de Seguridad Superior (Valor máximo no excedido)',
  'jeepneyActivity.safetyCapTip': 'Explicación: El resultado generado se limitará a no exceder el límite superior. Ingrese 0 para deshabilitar el límite superior.',
  'jeepneyActivity.previewAutoRefresh': 'Vista Previa (Actualización Automática)',
  'jeepneyActivity.currentStage': 'Etapa Actual',
  'jeepneyActivity.stage': 'Etapa',
  'jeepneyActivity.autoGenerate': 'Generar Automáticamente',
  'jeepneyActivity.autoGenerateFixed': 'Generar Automáticamente (Fijo)',
  'jeepneyActivity.autoGenerateRandom': 'Generar Automáticamente (Aleatorio)',
  'jeepneyActivity.manualGenerate': 'Generar Manualmente',
  'jeepneyActivity.randomReward': 'Recompensa Aleatoria: El valor se genera aleatoriamente dentro del rango',
  'jeepneyActivity.rewardColorTip.fixed': 'Recompensa fija con valor constante',
  'jeepneyActivity.rewardColorTip.random': 'Recompensa aleatoria con valor generado aleatoriamente dentro del rango',
  'jeepneyActivity.actualConsumptionNegativeWarning': 'El consumo real es negativo, lo que se considera anormal excepto para la etapa final y bloqueará el guardado',
  'jeepneyActivity.stageType.tail': 'Etapa Final',
  'jeepneyActivity.result': 'Resultado (Recompensa Correspondiente)',
  'jeepneyActivity.minValueExceedsMax': 'El valor mínimo no debe exceder el valor máximo',
  'jeepneyActivity.multiplierLessThanOne': 'La magnificación no puede ser menor que 1',
  'jeepneyActivity.multiplierMin': 'Debe ser mayor que o igual a 1',
  'jeepneyActivity.abnormalStatusMessage': 'Estado anormal: Cuando el valor mínimo es mayor que el valor máximo, o el ritmo de crecimiento es 0, o la magnificación es menor que 1, el guardado se bloqueará y se mostrará una solicitud durante la verificación.',
  'jeepneyActivity.finalStageConsumptionTooltip': 'Consumo real predeterminado = Umbral acumulado del nivel actual - Umbral acumulado del nivel anterior (Nivel 1 resta 0)\n• Niveles 1~N: El umbral acumulado debe aumentar estrictamente\n• Nivel Final N: El umbral acumulado debe ser ≥ anterior (permitido igual = diferencia de nivel final es 0)\n• No se puede consumir diferencia de nivel negativa (cálculo del sistema)\n• La modificación manual de un solo nivel, o consumo de nivel final, no se ve afectada por la configuración predeterminada.\nNota: Hacer clic en el botón de empuje en el lado del cliente avanzará definitivamente 1 nivel. Para evitar ningún movimiento después de hacer clic, si no se configura, el juego no se puede jugar.',
  'jeepneyActivity.finalStageConsumptionRequired': 'Por favor, ingrese el consumo de etapa final',
  'jeepneyActivity.distributionMethodRequired': 'Por favor, seleccione el método de distribución',
  'jeepneyActivity.turnoverMultiple': 'Rotación',
  'jeepneyActivity.turnoverMultipleRequired': 'Por favor, ingrese el multiplicador de rotación',
  'jeepneyActivity.times': 'veces',
  'jeepneyActivity.vipLevel': 'Nivel VIP',
  'jeepneyActivity.allowedCashOutStages': 'Etapas de Canje Permitidas',
  'jeepneyActivity.rewardSyncStrategy': 'Estrategia de Sincronización de Recompensa',
  'jeepneyActivity.rewardSyncStrategyRequired': 'Por favor, seleccione la estrategia de sincronización de recompensa',
  'jeepneyActivity.rewardSyncStrategy.coverAll': 'Cubrir Todas las Etapas',
  'jeepneyActivity.rewardSyncStrategy.merge': 'Fusionar Recompensas',
  'jeepneyActivity.configMethod': 'Método de Configuración',
  'jeepneyActivity.configMethodRequired': 'Por favor, seleccione el método de configuración',
  'jeepneyActivity.configMethod.autoGenerate': 'Generar Automáticamente',
  'jeepneyActivity.configMethod.manual': 'Manual',
  'jeepneyActivity.firstStageValue': 'Valor',
  'jeepneyActivity.firstStageValueRequired': 'Por favor, ingrese el valor',
  'jeepneyActivity.firstStageMinValueRequired': 'Por favor, ingrese el valor mínimo',
  'jeepneyActivity.firstStageMaxValueRequired': 'Por favor, ingrese el valor máximo',
  'jeepneyActivity.rewardConfigTip': 'Se recomienda que cada configuración de etapa sea cálculo real, verificación manual',
  'jeepneyActivity.useDefaultConfig': 'Usar Configuración Predeterminada',
  'jeepneyActivity.stageRewardConfig': 'Configuración de Recompensa de Etapa Única',
  'jeepneyActivity.generationRule': 'Regla de Generación',
  'jeepneyActivity.generateRandomRule': 'Generar Regla Aleatoria',
  'jeepneyActivity.generateFixedRule': 'Generar Regla Fija',
  'jeepneyActivity.fixedDistributionFormulaGeneration': 'Generación de Fórmula de Distribución Fija',
  'jeepneyActivity.fixedIncrease': 'Aumento Fijo',
  'jeepneyActivity.fixedIncreaseRequired': 'Por favor, ingrese el aumento fijo',
  'jeepneyActivity.fixedIncreasePerPeriod': 'Valor fijo aumentado por período',
  'jeepneyActivity.growthPeriod': 'Período de Crecimiento',
  'jeepneyActivity.roundingMethod': 'Método de Redondeo',
  'jeepneyActivity.roundingMethodRequired': 'Por favor, seleccione el método de redondeo',
  'jeepneyActivity.roundingMethod.round': 'Redondear al más cercano',
  'jeepneyActivity.roundingMethod.ceil': 'Redondear hacia arriba',
  'jeepneyActivity.roundingMethod.floor': 'Redondear hacia abajo',
  'jeepneyActivity.actualConsumptionStrategy': 'Estrategia de Consumo Real',
  'jeepneyActivity.consumptionStrategy.fixed': 'Fijo',
  'jeepneyActivity.consumptionStrategy.incremental': 'Incremental',
  'jeepneyActivity.inheritDefaultConsumption': 'Heredar Consumo Predeterminado',
  'jeepneyActivity.finalStageConsumptionEditTip': 'No afectará otras etapas, solo modifica el consumo real',
  'jeepneyActivity.settlementSettings': 'Configuración de Liquidación',
  'jeepneyActivity.settlementThreshold': 'Umbral de Liquidación',
  'jeepneyActivity.settlementThresholdTypeRequired': 'Por favor, seleccione el tipo de umbral de liquidación',
  'jeepneyActivity.completeFinalStage': 'Completar Etapa Final',
  'jeepneyActivity.occurredInRound': 'Al menos sucedió en esta ronda',
  'jeepneyActivity.inviteValidUsers': 'Invitar Usuarios Válidos ≥',
  'jeepneyActivity.inviteValidUsersRequired': 'Por favor, ingrese usuarios válidos invitados',
  'jeepneyActivity.weightCalculation': 'Cálculo de Peso',
  'jeepneyActivity.rechargeWeight': 'Peso de Recarga por Vez',
  'jeepneyActivity.rechargeWeightRequired': 'Por favor, ingrese el peso de recarga por vez',
  'jeepneyActivity.inviteWeight': 'Peso de Invitación por Persona',
  'jeepneyActivity.inviteWeightRequired': 'Por favor, ingrese el peso de invitación por persona',
  'jeepneyActivity.dynamicProbability': 'Probabilidad Dinámica',
  'jeepneyActivity.round': 'Ronda',
  'jeepneyActivity.baseProbability': 'Probabilidad Base(%)',
  'jeepneyActivity.baseProbabilityRequired': 'Por favor, ingrese la probabilidad base',
  'jeepneyActivity.weightConversionFactor': 'Factor de Conversión de Peso',
  'jeepneyActivity.weightConversionFactorRequired': 'Por favor, ingrese el factor de conversión de peso',
  'jeepneyActivity.failureIncreasePerTime': 'Aumento de Fallo por Vez(%)',
  'jeepneyActivity.failureIncreasePerTimeRequired': 'Por favor, ingrese el aumento de fallo por vez',
  'jeepneyActivity.failureIncreaseCap': 'Límite de Aumento de Fallo(%)',
  'jeepneyActivity.failureIncreaseCapRequired': 'Por favor, ingrese el límite de aumento de fallo',
  'jeepneyActivity.minProbability': 'Probabilidad Mínima(%)',
  'jeepneyActivity.minProbabilityRequired': 'Por favor, ingrese la probabilidad mínima',
  'jeepneyActivity.maxProbability': 'Probabilidad Máxima(%)',
  'jeepneyActivity.maxProbabilityRequired': 'Por favor, ingrese la probabilidad máxima',
  'jeepneyActivity.actualProbability': 'Probabilidad Real',
  'jeepneyActivity.noDynamicProbabilityRounds': 'Aún no hay configuración de probabilidad dinámica, haga clic en \"Agregar Nuevo\" para agregar',
  'jeepneyActivity.roundExplanation': 'Solo después de completar la etapa final (Etapa N), la ronda aumenta en 1; los canjes intermedios no se cuentan como rondas.',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.edit': 'Editar',
  'common.apply': 'Aplicar',
  'common.on': 'Activado',
  'common.off': 'Desactivado',
  'common.allow': 'Permitir',
  'common.disallow': 'No Permitir',
  'jeepneyActivity.settlementFailureSettings': 'Configuración de Fallo de Liquidación',
  'jeepneyActivity.settlementFailureTaskSettings': 'Configuración de Tarea de Fallo de Liquidación',
  'jeepneyActivity.settlementFailureTaskRuleTip': 'Al configurar operaciones, asegúrese de que los niveles de recuento de fallos sean claros para evitar confusión causada por múltiples configuraciones para el mismo recuento de fallos.',
  'jeepneyActivity.failureCount': 'Recuento de Fallos',
  'jeepneyActivity.failureCountRequired': 'Por favor, seleccione el recuento de fallos',
  'jeepneyActivity.inviteValidFriendsRequired': 'Por favor, ingrese el número de amigos válidos invitados',
  'jeepneyActivity.noRechargeTasks': 'Aún no hay configuración de tarea de recarga, haga clic en \"Agregar Nuevo\" para agregar',
  'jeepneyActivity.noInviteTasks': 'Aún no hay configuración de tarea de invitación, haga clic en \"Agregar Nuevo\" para agregar',
  // Bet Milestone (Daily / Weekly)
  'chickActivity.dailyBetMilestone': 'Hito de Apuesta (Diario)',
  'chickActivity.weeklyBetMilestone': 'Hito de Apuesta (Semanal)',
  'chickActivity.dailyBetMilestoneDesc': 'Las recompensas se escriben en el cofre del tesoro al completar y deben reclamarse manualmente. Sin cuenta regresiva independiente de 24h; una nueva tarea comienza a las 00:00 del día siguiente, y las recompensas sin reclamar del día anterior se anulan automáticamente. Sin requisito de resistencia; resistencia = 0 (Enfermo) también puede participar.',
  'chickActivity.weeklyBetMilestoneDesc': 'Las recompensas se escriben en el cofre del tesoro al completar y deben reclamarse manualmente. Sin cuenta regresiva independiente de 24h; una nueva tarea semanal comienza a las 00:00 del próximo lunes, y las recompensas sin reclamar de la semana pasada se anulan automáticamente. Sin requisito de resistencia.',
  'chickActivity.dailyTemplateHint': ' — {amount}/{reward} relleno automático de cada umbral de fila y recompensa; la tabla completa comparte una plantilla.',
  'chickActivity.weeklyTemplateHint': ' — {amount}/{reward} relleno automático de cada umbral de fila y recompensa; la tabla completa comparte una plantilla.',
  'chickActivity.newBadge': 'Nuevo',
  'chickActivity.copyPreview': 'Copiar Vista Previa (automático)',
  'chickActivity.autoGenReadonly': 'Generado automáticamente, solo lectura',
  'chickActivity.milestoneCondition': 'Condición',
  'chickActivity.currencyThreshold': 'Umbral de Múltiples Monedas',
  'chickActivity.rewardValue': 'Valor de Recompensa',
  'chickActivity.turnoverMultiple': 'Multiplicador de Rotación',
  'chickActivity.copyTemplateMultiLang': 'Copiar Plantilla (Multiidioma)',
  'chickActivity.templatePlaceholderHint': 'Marcadores de posición: {amount} (umbral), {reward} (valor de recompensa). La tabla completa comparte una plantilla.',
  'chickActivity.globalCurrencySettings': 'Configuración de Múltiples Monedas Global',
  'chickActivity.globalRateHint': 'Establezca el valor convertido de 1 {base} para cada moneda; los niveles establecidos en \"Usar Global\" convierten el umbral en consecuencia.',
  'chickActivity.ratePerBase': '1 {base} =',
  'chickActivity.baseCurrencyHint': 'Cada nivel se configura según {base}; otras monedas convierten según la configuración global anterior de forma predeterminada, y cada nivel puede anular.',
  'chickActivity.currencyThresholdSettings': 'Configuración de Umbral de Múltiples Monedas',
  'chickActivity.currencyThresholdModalDesc': 'Deje en blanco para usar la conversión global para esa moneda; complete para usar un umbral personalizado para este nivel.',
  'chickActivity.threshold': 'Umbral',
  'chickActivity.resetToGlobal': 'Restablecer para Usar Global',
  'chickActivity.addTierSlot': 'Agregar Nivel',
  'chickActivity.notConfigured': 'No configurado',
  'chickActivity.selectCurrency': 'Seleccionar moneda',
  'chickActivity.milestoneCurrencyHint': 'Cada moneda tiene sus propios niveles; cambie la moneda anterior para editar los niveles de esa moneda. Las monedas son independientes entre sí.',
  'chickActivity.milestoneRuleEnergy': 'Los hitos de apuesta no tienen requisito de resistencia; cualquier nivel de resistencia (incluyendo 0 / Enfermo) puede acumular y reclamar.',
  'chickActivity.milestoneRuleClaim': 'Al completar, las recompensas de hito de apuesta se escriben en el cofre del tesoro y deben reclamarse manualmente; sin cuenta regresiva independiente de 24h — cuando una nueva ronda comienza a las 00:00 diariamente / 00:00 del lunes semanalmente, las recompensas logradas pero sin reclamar de la ronda anterior se anulan automáticamente.',

  // Common - Weekdays
  'common.weekday.monday': 'Lunes',
  'common.weekday.tuesday': 'Martes',
  'common.weekday.wednesday': 'Miércoles',
  'common.weekday.thursday': 'Jueves',
  'common.weekday.friday': 'Viernes',
  'common.weekday.saturday': 'Sábado',
  'common.weekday.sunday': 'Domingo',

  // Red Packet Activity
  'redPacket.title': 'Configuración de Sobre Rojo',
  'redPacket.name': 'Nombre del Sobre Rojo',
  'redPacket.enterName': 'Por favor, ingrese el nombre del sobre rojo',
  'redPacket.ruleTitle': 'Título de la regla',
  'redPacket.enterRuleTitle': 'Por favor, ingrese el título de la regla',
  'redPacket.ruleContent': 'Descripción de la regla',
  'redPacket.enterRuleContent': 'Por favor, ingrese la descripción de la regla',
  'redPacket.currency': 'Moneda',
  'redPacket.selectCurrency': 'Por favor, seleccione la moneda',
  'redPacket.addRedPacket': 'Agregar Sobre Rojo',
  'redPacket.editRedPacket': 'Editar Sobre Rojo',
  'redPacket.createSuccess': 'Creado exitosamente',
  'redPacket.updateSuccess': 'Actualizado exitosamente',
  'redPacket.hasIssueRecordsTip': 'Esta actividad tiene registros de problemas existentes. El tipo de usuario, período de estadísticas, tipos de eventos, tipo de distribución, método de distribución y rango de cantidad de sobre rojo no se pueden cambiar. Solo se pueden editar el nombre, tiempo de distribución y validez de reclamo.',
  'redPacket.deleteSuccess': 'Eliminado exitosamente',
  'redPacket.confirmDelete': '¿Está seguro de que desea eliminar esta actividad de sobre rojo?',
  'redPacket.dataLoadFailed': 'Error al cargar datos',
  'redPacket.operation': 'Operación',

  'redPacket.stats.title': 'Estadísticas de Lluvia de Sobre Rojo',
  'redPacket.stats.redPacketName': 'Nombre del Sobre Rojo',
  'redPacket.stats.distributionTime': 'Tiempo de Distribución',
  'redPacket.stats.distributionMethod': 'Método de Distribución',
  'redPacket.stats.userCount': 'Usuarios Distribuidos',
  'redPacket.stats.totalAmount': 'Cantidad Real',
  'redPacket.stats.settings': 'Configuración',
  'redPacket.stats.viewMemberList': 'Ver Lista',
  'redPacket.stats.memberAccount': 'Cuenta de Miembro',
  'redPacket.stats.amount': 'Cantidad',
  'redPacket.stats.claimTime': 'Hora de Reclamo',
  'redPacket.stats.exportMemberList': 'Exportar Lista',
  'redPacket.stats.loadFailed': 'Error al cargar',
  'redPacket.stats.memberListLoadFailed': 'Error al cargar la lista de miembros',

  'redPacket.distributionType.label': 'Tipo de Distribución',
  'redPacket.distributionType.daily': 'Diario',
  'redPacket.distributionType.weekly': 'Semanal',
  'redPacket.distributionType.monthly': 'Mensual',
  'redPacket.distributionType.specified': 'Especificado',
  'redPacket.selectDistributionType': 'Por favor, seleccione el tipo de distribución',

  'redPacket.distributionTime': 'Tiempo de Distribución',
  'redPacket.selectDistributionTime': 'Por favor, seleccione el tiempo de distribución',
  'redPacket.weekDay': 'Día de Semana',
  'redPacket.selectWeekDay': 'Por favor, seleccione el día de la semana',
  'redPacket.monthDay': 'Día',
  'redPacket.selectMonthDay': 'Por favor, seleccione el día',
  'redPacket.time': 'Hora',
  'redPacket.selectTime': 'Por favor, seleccione la hora',

  'redPacket.distributionMethod.label': 'Método de Distribución',
  'redPacket.distributionMethod.scheduled': 'Reclamo Programado',
  'redPacket.distributionMethod.popup': 'Reclamo Emergente',
  'redPacket.distributionMethod.autoCredit': 'Crédito Automático',
  'redPacket.selectDistributionMethod': 'Por favor, seleccione el método de distribución',

  'redPacket.claimValidity': 'Validez de Reclamo',
  'redPacket.enterValidityValue': 'Ingrese el valor de validez',
  'redPacket.selectValidityUnit': 'Seleccione la unidad',
  'redPacket.validityUnit.minute': 'Minuto(s)',
  'redPacket.validityUnit.day': 'Día(s)',

  'redPacket.amountRange': 'Rango de cantidad del sobre rojo',
  'redPacket.amountConfig': 'Configuración de cantidad',
  'redPacket.minAmount': 'Cantidad mínima',
  'redPacket.enterMinAmount': 'Ingrese la cantidad mínima',
  'redPacket.maxAmount': 'Cantidad máxima',
  'redPacket.enterMaxAmount': 'Ingrese la cantidad máxima',

  'redPacket.userType.label': 'Tipo de usuario',
  'redPacket.userType.nonFirstDeposit': 'Sin primer depósito',
  'redPacket.userType.nonfirstdeposit': 'Sin primer depósito',
  'redPacket.userType.firstDeposit': 'Primer depósito',
  'redPacket.userType.firstdeposit': 'Primer depósito',
  'redPacket.userType.specifiedUser': 'Usuario especificado',
  'redPacket.userType.specifieduser': 'Usuario especificado',
  'redPacket.selectUserType': 'Seleccione el tipo de usuario',
  'redPacket.userConfig': 'Configuración de usuario',

  'redPacket.uploadMemberList': 'Subir lista',
  'redPacket.uploadMemberListTip': 'Por favor suba un archivo CSV, formato: el encabezado de la primera fila es memberAccount, cada fila contiene una cuenta',
  'redPacket.memberListRequired': 'Por favor suba la lista de miembros',
  'redPacket.memberCount': '{count} miembros',
  'redPacket.specifiedUsers': 'Usuarios especificados',

  'redPacket.statisticsTime': 'Tiempo de estadísticas',
  'redPacket.statisticsConfig': 'Configuración de estadísticas',
  'redPacket.statisticsCycle.label': 'Ciclo de estadísticas',
  'redPacket.statisticsCycle.weekly': 'Semanal',
  'redPacket.statisticsCycle.monthly': 'Mensual',
  'redPacket.selectStatisticsCycle': 'Seleccione el ciclo de estadísticas',
  'redPacket.userTypeStatisticsCycle.label': 'Ciclo de estadísticas por tipo de usuario',
  'redPacket.statisticsStartDay': 'Día de inicio',
  'redPacket.selectStartDay': 'Seleccione el día de inicio',
  'redPacket.statisticsEndDay': 'Día de fin',
  'redPacket.selectEndDay': 'Seleccione el día de fin',
  'redPacket.statisticsEffectiveTime.label': 'Tiempo efectivo de estadísticas',
  'redPacket.turnoverMultiple.label': 'Múltiplo de rotación',
  'redPacket.turnoverMultiple.placeholder': 'Ingrese el múltiplo de rotación',
  'redPacket.turnoverMultiple.required': 'Por favor ingrese el múltiplo de rotación',
  'redPacket.statisticsEffectiveTime.placeholder': 'Seleccione el tiempo efectivo de estadísticas',
  'redPacket.statisticsEffectiveTime.tooltip': 'Solo se contarán los datos después de este momento, evitando que se incluyan datos históricos',
  'redPacket.statisticsRange': 'Rango de estadísticas',

  'redPacket.cycleMismatchWeekly': 'Para estadísticas semanales, la distribución solo puede ser Diaria o Semanal',
  'redPacket.cycleMismatchMonthly': 'Para estadísticas mensuales, la distribución solo puede ser Mensual o Especificada',

  'redPacket.eventType.label': 'Tipo de evento',
  'redPacket.eventType.deposit': 'Depósito',
  'redPacket.eventType.bet': 'Apuesta',
  'redPacket.eventType.negativeProfit': 'Ganancia negativa',
  'redPacket.eventType.negativeprofit': 'Ganancia negativa',
  'redPacket.eventType.negative_profit': 'Ganancia negativa',
  'redPacket.eventType.balance': 'Saldo',
  'redPacket.selectEventType': 'Seleccione el tipo de evento',
  'redPacket.addEventType': 'Añadir tipo de evento',
  'redPacket.eventTypeConfig': 'Configuración de tipo de evento',
  'redPacket.eventTypeRequired': 'Por favor agregue al menos un tipo de evento',

  // FBMPLAY-1737 阶梯配置
  'redPacket.tier.section': 'Configuración por niveles',
  'redPacket.tier.title': 'Nivel',
  'redPacket.tier.add': 'Añadir nivel',
  'redPacket.tier.remove': 'Eliminar nivel',
  'redPacket.tier.conditionMin': 'Monto mínimo de condición',
  'redPacket.tier.conditionMax': 'Monto máximo de condición',
  'redPacket.tier.noLimitPlaceholder': 'Vacío = sin límite superior',
  'redPacket.tier.noLimit': 'Sin límite',
  'redPacket.tier.rewardMin': 'Monto mínimo a entregar',
  'redPacket.tier.rewardMax': 'Monto máximo a entregar',
  'redPacket.tier.required': 'Configure al menos un nivel',
  'redPacket.tier.conditionMinRequired': 'Ingrese el monto mínimo de condición',
  'redPacket.tier.conditionMaxRequired': 'Ingrese el monto máximo de condición (solo el último nivel puede quedar vacío)',
  'redPacket.tier.conditionRangeInvalid': 'El monto mínimo de condición no puede superar al máximo',
  'redPacket.tier.rewardRequired': 'Ingrese el monto mínimo/máximo a entregar',
  'redPacket.tier.rewardRangeInvalid': 'El monto mínimo a entregar no puede superar al máximo',
  'redPacket.tier.multipleRequired': 'Ingrese el múltiplo de rotación',
  'redPacket.tier.overlap': 'El monto mínimo de condición debe ser mayor que el máximo del nivel anterior (niveles ascendentes sin solapamiento)',
  'redPacket.tier.hint': 'El tipo de evento es común a todos los niveles; los rangos de condición deben ser ascendentes y sin solapamiento, el máximo vacío en el último nivel significa sin límite; el usuario recibe el nivel más alto alcanzado',
  'redPacket.tier.legacyHint': 'Esta actividad usa la configuración antigua (varios eventos / monto fijo) y ya no se evalúa tras la actualización; configure el tipo de evento y los niveles antes de guardar',
  'redPacket.tier.legacyTag': 'Antiguo',

  'redPacket.distributionConfig': 'Configuración de distribución',

  // Treasure Box
  'treasureBox.config.title': 'Configuración del cofre del tesoro',
  'treasureBox.config.activityStatus': 'Estado de la actividad',
  'treasureBox.config.enabled': 'Habilitado',
  'treasureBox.config.disabled': 'Deshabilitado',
  'treasureBox.config.activityThreshold': 'Umbral de actividad',
  'treasureBox.config.activityThresholdDesc': 'Después de la medianoche diariamente, distribuir aleatoriamente cofres a usuarios con actividad de check-in >= este valor',
  'treasureBox.config.dailyBoxLimit': 'Límite diario de cofres',
  'treasureBox.config.dailyBoxLimitDesc': 'Número máximo de cofres distribuidos cada 24 horas',
  'treasureBox.config.levelConfig': 'Configuración del nivel del cofre',
  'treasureBox.config.levelName': 'Nombre del nivel',
  'treasureBox.config.dropRate': 'Tasa de caída (%)',
  'treasureBox.config.expireHours': 'Horas de caducidad',
  'treasureBox.config.prizeConfig': 'Configuración de premio (Bonificación)',
  'treasureBox.config.flowMultiple': 'Múltiplo de flujo',
  'treasureBox.config.setup': 'Configurar',
  'treasureBox.config.save': 'Guardar',
  'treasureBox.config.saveSuccess': 'Guardado exitoso',
  'treasureBox.config.saveFailed': 'Error al guardar',
  'treasureBox.config.loadFailed': 'Error al cargar la configuración',
  'treasureBox.config.dropRateSumError': 'Todas las tasas de caída del nivel deben sumar 100%, actualmente {total}%',
  'treasureBox.config.enableGuard': 'Antes de habilitar: las tasas de caída deben sumar 100%, y cada nivel con una tasa de caída > 0 debe tener rangos de premio configurados',
  'treasureBox.config.statusUpdateSuccess': 'Estado actualizado exitosamente',
  'treasureBox.config.statusUpdateFailed': 'Error al actualizar el estado',
  'treasureBox.config.prizeConfigTitle': 'Configuración de premio',
  'treasureBox.config.minAmount': 'Cantidad mínima',
  'treasureBox.config.maxAmount': 'Cantidad máxima',
  'treasureBox.config.probability': 'Probabilidad (%)',
  'treasureBox.config.addRange': 'Añadir rango',
  'treasureBox.config.prizeProbSumError': 'Todas las probabilidades del rango de premio deben sumar 100%, actualmente {total}%',
  'treasureBox.config.currentPrize': 'Rangos de premio actuales',

  'treasureBox.level.WOOD': 'Cofre de madera',
  'treasureBox.level.IRON': 'Cofre de hierro',
  'treasureBox.level.BRONZE': 'Cofre de bronce',
  'treasureBox.level.SILVER': 'Cofre de plata',
  'treasureBox.level.GOLD': 'Cofre de oro',
  'treasureBox.level.DIAMOND': 'Cofre de diamante',

  'treasureBox.stats.title': 'Estadísticas del cofre',
  'treasureBox.stats.dateRange': 'Rango de fechas',
  'treasureBox.stats.search': 'Buscar',
  'treasureBox.stats.reset': 'Restablecer',
  'treasureBox.stats.levelName': 'Nombre del nivel',
  'treasureBox.stats.statsDate': 'Fecha',
  'treasureBox.stats.coinCode': 'Moneda',
  'treasureBox.records.coinCode': 'Moneda',
  'treasureBox.stats.grantCount': 'Otorgados',
  'treasureBox.stats.openCount': 'Abiertos',
  'treasureBox.stats.expiredCount': 'Expirados',
  'treasureBox.stats.totalPrizeAmount': 'Cantidad total de premios',
  'treasureBox.stats.keyGrantCount': 'Llaves otorgadas',
  'treasureBox.stats.keyUsedCount': 'Llaves usadas',
  'treasureBox.stats.timeRequired': 'Por favor seleccione un rango de fechas',
  'treasureBox.stats.queryFailed': 'Error al consultar estadísticas',

  'treasureBox.records.title': 'Registros de distribución de cofres',
  'treasureBox.records.boxId': 'ID del cofre',
  'treasureBox.records.memberAccount': 'Cuenta de miembro',
  'treasureBox.records.memberInfoId': 'ID de usuario',
  'treasureBox.records.keyId': 'ID de llave',
  'treasureBox.records.levelCode': 'Nivel del cofre',
  'treasureBox.records.grantTime': 'Tiempo de otorgamiento',
  'treasureBox.records.expireTime': 'Tiempo de caducidad',
  'treasureBox.records.openTime': 'Tiempo de apertura',
  'treasureBox.records.openKeyId': 'Abrir ID de llave',
  'treasureBox.records.prizeAmount': 'Cantidad del premio',
  'treasureBox.records.flowMultiple': 'Múltiplo de flujo',
  'treasureBox.records.tradeNo': 'No. de transacción',
  'treasureBox.records.search': 'Buscar',
  'treasureBox.records.reset': 'Restablecer',
  'treasureBox.records.queryFailed': 'Error al consultar registros',
  'treasureBox.records.selectLevel': 'Seleccione el nivel del cofre',
  'treasureBox.records.allLevels': 'Todos los niveles',
  'treasureBox.records.boxStatus': 'Estado del cofre',
  'treasureBox.records.boxStatus.pending': 'Pendiente',
  'treasureBox.records.boxStatus.opened': 'Abierto',
  'treasureBox.records.boxStatus.expired': 'Expirado',
  'treasureBox.records.grantSource': 'Fuente de otorgamiento',
  'treasureBox.records.grantSource.autoGrant': 'Otorgamiento automático diario',
  'treasureBox.records.grantSource.activityReward': 'Recompensa de actividad',
  'treasureBox.records.selectBoxStatus': 'Seleccione el estado del cofre',
  'treasureBox.records.selectGrantSource': 'Seleccione la fuente de otorgamiento',
  'treasureBox.records.timeRequired': 'Por favor seleccione al menos un rango de fechas',
  'treasureBox.records.keyDataPkCode': 'Código de llave de apertura',

  // ========== Free Spin Grant ==========

  // Whitelist

  // Grant

  // Grant list & search

  // Batch

  // Batch status

  // Detail

  // Detail status

  // Stats
  'freeSpin.stat.total': 'Total',
  'freeSpin.stat.success': 'Exitoso',
  'freeSpin.stat.fail': 'Fallido',
  'activity.search': 'Buscar',
  'activity.all': 'Todos',

  // ===== Vendor Leaderboard =====
  'activity.vendorLeaderboard.title': 'Clasificación de proveedores',
  'activity.vendorLeaderboard.boardConfigTitle': 'B · Configuración del tablero',
  'activity.vendorLeaderboard.boardConfigTip': 'Cada tablero es independiente: alcance del juego / miembros / métrica de clasificación / recompensas / distribución. Cambie de tablero arriba para configurar por separado.',
  'activity.vendorLeaderboard.addBoard': 'Añadir tablero',
  'activity.vendorLeaderboard.board': 'Tablero',
  'activity.vendorLeaderboard.overallBoard': 'Resumen diario',
  'activity.vendorLeaderboard.unnamedBoard': 'Tablero sin nombre',
  'activity.vendorLeaderboard.confirmRemoveBoard': '¿Eliminar este tablero?',
  'activity.vendorLeaderboard.boardBasic': 'Conceptos básicos del tablero',
  'activity.vendorLeaderboard.boardNameZh': 'Nombre del tablero (ZH)',
  'activity.vendorLeaderboard.boardNameZhTip': 'Nombre de pestaña del front-end en chino',
  'activity.vendorLeaderboard.boardNameEn': 'Nombre del tablero (EN)',
  'activity.vendorLeaderboard.boardNameEnTip': 'Nombre de pestaña del front-end en inglés',
  'activity.vendorLeaderboard.boardSort': 'Orden de visualización (orden de pestaña del front-end)',
  'activity.vendorLeaderboard.boardSortTip': 'El valor menor se muestra primero',
  'activity.vendorLeaderboard.boardBanner': 'Banner del tablero (front-end, por tablero)',
  'activity.vendorLeaderboard.boardBannerTip': 'Suba un banner para cada plataforma',
  'activity.vendorLeaderboard.bannerH5': 'Banner H5',
  'activity.vendorLeaderboard.bannerPc': 'Banner PC',
  'activity.vendorLeaderboard.bannerApp': 'Banner de aplicación',
  'activity.vendorLeaderboard.gameScope': 'Alcance del tablero',
  'activity.vendorLeaderboard.gameScopeTip': 'Seleccione qué juegos cuentan para este tablero: Categoría / Plataforma / Juego (3 niveles). Un padre marcado parcialmente significa selección parcial. 6 categorías fijas; Solo deportes a nivel de plataforma.',
  'activity.vendorLeaderboard.searchGame': 'Buscar juego',
  'activity.vendorLeaderboard.catSlot': 'Tragamonedas',
  'activity.vendorLeaderboard.catCasino': 'Casino',
  'activity.vendorLeaderboard.catPoker': 'Póquer',
  'activity.vendorLeaderboard.catBingo': 'Bingo',
  'activity.vendorLeaderboard.catSports': 'Deportes',
  'activity.vendorLeaderboard.catFish': 'Pesca',
  'activity.vendorLeaderboard.memberScope': 'Miembros participantes',
  'activity.vendorLeaderboard.joinMember': 'Miembros',
  'activity.vendorLeaderboard.memberAll': 'Todos los miembros',
  'activity.vendorLeaderboard.memberVip': 'Niveles VIP especificados',
  'activity.vendorLeaderboard.vipLevels': 'Niveles VIP',
  'activity.vendorLeaderboard.rankSource': 'Métrica de clasificación y fuente de datos',
  'activity.vendorLeaderboard.metric': 'Métrica de clasificación',
  'activity.vendorLeaderboard.metricValidBet': 'Apuesta válida (Tablero de apuestas)',
  'activity.vendorLeaderboard.metricProfit': 'Ganancia (Tablero de ganancias)',
  'activity.vendorLeaderboard.metricLoss': 'Pérdida (Tablero de pérdidas)',
  'activity.vendorLeaderboard.rankSourceTip': 'La fuente de datos reutiliza los tableros de clasificación de usuario (apuesta / ganancia / pérdida), el período incluye tiempo real (actual) + ayer (último tablero fijo), contado por ciclo natural (no rodante). La columna de valor del front-end sigue la métrica: apuesta válida / ganancia / pérdida. Las apuestas inválidas, coberturas y apuestas coincidentes se juzgan por el control de riesgo de la plataforma y la capa de datos.',
  'activity.vendorLeaderboard.minThreshold': 'Umbral mínimo del tablero (PHP)',
  'activity.vendorLeaderboard.minThresholdTip': 'La apuesta válida por debajo de esto no entra en el tablero',
  'activity.vendorLeaderboard.minBoardCount': 'Número mínimo de jugadores del tablero',
  'activity.vendorLeaderboard.minBoardCountTip': 'Cuando es insuficiente, las clasificaciones vacías no se pagan para evitar arbitraje de bajo tráfico',
  'activity.vendorLeaderboard.optional': 'Opcional',
  'activity.vendorLeaderboard.rewardLadder': 'Escala de recompensas',
  'activity.vendorLeaderboard.importExcel': 'Subir Excel',
  'activity.vendorLeaderboard.downloadTemplate': 'Descargar plantilla',
  'activity.vendorLeaderboard.importTip': 'Campos de plantilla: Clasificación (o rango inicio · fin) · Cantidad · Tipo de recompensa (Efectivo / Puntos / Entrada de giro) · Valor de recompensa · Múltiplo de flujo (para efectivo) · Tipo de giro (para entrada). La importación sobrescribe la escala actual.',
  'activity.vendorLeaderboard.importEmpty': 'No se analizaron datos válidos',
  'activity.vendorLeaderboard.importSuccess': 'Se importaron {{count}} niveles',
  'activity.vendorLeaderboard.importFail': 'Fallo en la importación, por favor verifique el formato del archivo',
  'activity.vendorLeaderboard.enableRankRange': 'Habilitar rango de clasificación',
  'activity.vendorLeaderboard.enableRankRangeTip': 'Por defecto cada clasificación se configura por separado; una vez habilitado, puede asignar por lotes la misma recompensa a un rango (ej. 4~10)',
  'activity.vendorLeaderboard.rank': 'Clasificación',
  'activity.vendorLeaderboard.count': 'Cantidad',
  'activity.vendorLeaderboard.rewardContent': 'Recompensas (múltiples)',
  'activity.vendorLeaderboard.rewardValue': 'Valor',
  'activity.vendorLeaderboard.rewardCash': 'Efectivo',
  'activity.vendorLeaderboard.rewardPoint': 'Puntos',
  'activity.vendorLeaderboard.rewardSpinTicket': 'Entrada de giro',
  'activity.vendorLeaderboard.flowLabel': 'Flujo',
  'activity.vendorLeaderboard.times': 'x',
  'activity.vendorLeaderboard.selectSpinType': 'Seleccione el tipo de giro',
  'activity.vendorLeaderboard.addReward': 'Añadir recompensa',
  'activity.vendorLeaderboard.addRank': 'Añadir clasificación',
  'activity.vendorLeaderboard.operation': 'Acción',
  'activity.vendorLeaderboard.delete': 'Eliminar',
  'activity.vendorLeaderboard.settlement': 'Liquidación y distribución',
  'activity.vendorLeaderboard.settleCycle': 'Ciclo de liquidación (días)',
  'activity.vendorLeaderboard.settleCycleTip': 'Número de días contados desde el inicio activo del tablero (no vinculado a una semana natural); liquidado y reiniciado cada N días',
  'activity.vendorLeaderboard.days': 'días',
  'activity.vendorLeaderboard.boardTime': 'Tiempo activo del tablero',
  'activity.vendorLeaderboard.boardTimeTip': 'Hora de inicio / fin de este tablero; debe caer dentro del rango de tiempo activo de la actividad',
  'activity.vendorLeaderboard.errBoardTimeRequired': 'Por favor establezca el tiempo activo para el tablero "{{name}}"',
  'activity.vendorLeaderboard.errBoardTimeOrder': 'La hora de inicio del tablero "{{name}}" debe ser anterior a la hora de fin',
  'activity.vendorLeaderboard.errBoardTimeWithinActivity': 'El tiempo activo del tablero "{{name}}" debe estar dentro del rango de tiempo activo de la actividad',
  'activity.vendorLeaderboard.errSettleCycle': 'El ciclo de liquidación del tablero "{{name}}" debe ser un número de días mayor que 0',
  'activity.vendorLeaderboard.tieRule': 'Regla de desempate',
  'activity.vendorLeaderboard.tieFirstReach': 'El primero en llegar gana',
  'activity.vendorLeaderboard.arrivalTiming': 'Timing de llegada',
  'activity.vendorLeaderboard.arrivalTimingFixed': 'Día siguiente 16:00',
  'activity.vendorLeaderboard.arrivalTimingTip': 'Pagado antes de las 16:00 del día siguiente después de que el tablero se fije (sistema-fijo)',
  'activity.vendorLeaderboard.distributeMode': 'Distribución',
  'activity.vendorLeaderboard.distributeDirect': 'Directo a la cuenta del usuario',
  'activity.vendorLeaderboard.distributeClaim': 'El usuario debe reclamar',
  'activity.vendorLeaderboard.rewardExpireDays': 'Días de caducidad de recompensa (-1 = nunca)',
  'activity.vendorLeaderboard.rewardExpireDaysTip': '-1 significa que nunca caduca',
  'activity.vendorLeaderboard.grantAudit': 'Revisión de otorgamiento',
  'activity.vendorLeaderboard.grantAuditTip': 'Activado = pagar después de la revisión de operaciones; Desactivado = pago automático sin revisión',
  'activity.vendorLeaderboard.on': 'Activado',
  'activity.vendorLeaderboard.off': 'Desactivado',
  'activity.vendorLeaderboard.activityRule': 'Reglas de actividad (configuración de operaciones, por tablero)',
  'activity.vendorLeaderboard.ruleTip': 'Los operadores completan las reglas de actividad línea por línea para que coincidan con la descripción de gameplay del front-end. Los elementos se pueden agregar/eliminar y se muestran en orden en el popup de reglas del front-end. Complete un conjunto por idioma (ZH / EN).',
  'activity.vendorLeaderboard.ruleItems': 'Elementos de regla',
  'activity.vendorLeaderboard.ruleItemPlaceholder': 'Ingrese un elemento de regla',
  'activity.vendorLeaderboard.addRuleItem': 'Añadir elemento de regla',
  'activity.vendorLeaderboard.errNoBoard': 'Configure al menos un tablero',
  'activity.vendorLeaderboard.errBoardName': 'El tablero "{{name}}" requiere nombres en ZH e EN',
  'activity.vendorLeaderboard.errVip': 'Tablero "{{name}}": por favor seleccione niveles VIP',
  'activity.vendorLeaderboard.errNoReward': 'Tablero "{{name}}": configure al menos un nivel de recompensa',
  'activity.vendorLeaderboard.errRewardValue': 'Tablero "{{name}}": el valor de recompensa debe ser mayor que 0',
  'activity.vendorLeaderboard.errSpinTicket': 'Tablero "{{name}}": por favor seleccione un tipo de giro',
  'activity.vendorLeaderboard.errLastBoard': 'Mantenga al menos un tablero',
  'activity.vendorLeaderboard.errRankOverlap': 'Tablero "{{name}}": las clasificaciones están duplicadas o se superponen, por favor verifique',
  'activity.vendorLeaderboard.rankConflictHint': 'Las clasificaciones están duplicadas o se superponen (resaltadas). Cada clasificación solo se puede configurar una vez — por favor ajuste antes de guardar',
  'fsBatch.platformCode': 'Código de plataforma',
  'fsBatch.currency': 'Moneda',
  'fsBatch.batchNo': 'No. de lote',
  'fsBatch.status': 'Estado',
  'fsBatch.query': 'Buscar',
  'fsBatch.reset': 'Restablecer',
  'fsBatch.dispatchTime': 'Tiempo de envío',
  'fsBatch.finishTime': 'Tiempo de finalización',
  'fsBatch.addDispatch': 'Nuevo envío',
  'fsBatch.games': 'Juegos',
  'fsBatch.rounds': 'Rondas',
  'fsBatch.total': 'Total',
  'fsBatch.expanded': 'Generado',
  'fsBatch.progress': 'Progreso',
  'fsBatch.action': 'Acción',
  'fsBatch.detail': 'Detalles',
  'fsBatch.viewProgress': 'Ver progreso',
  'fsBatch.refreshProgress': 'Actualizar',
  'fsBatch.progressText': 'Exitoso {{success}} / Fallido {{fail}} / Pendiente {{pending}}',
  'fsBatch.batchStatus.0': 'Creado',
  'fsBatch.batchStatus.1': 'Generando',
  'fsBatch.batchStatus.2': 'Enviando',
  'fsBatch.batchStatus.3': 'Realizado',
  'fsBatch.batchStatus.4': 'Parcialmente fallido',
  'fsBatch.batchStatus.5': 'Fallido',
  'fsBatch.submitTitle': 'Nuevo envío de giro gratis',
  'fsBatch.platformCodeRequired': 'Por favor ingrese el código de plataforma',
  'fsBatch.platformCodePlaceholder': 'ej. SL_FC',
  'fsBatch.currencyRequired': 'Por favor seleccione la moneda',
  'fsBatch.currencyPlaceholder': 'Por favor seleccione la moneda',
  'fsBatch.gameIds': 'IDs de juego',
  'fsBatch.gameIdsRequired': 'Por favor seleccione juegos',
  'fsBatch.gameIdsPlaceholder': 'Seleccione juegos (múltiples)',
  'fsBatch.gameIdsEmpty': 'Seleccione primero una plataforma, o agregue juegos en la lista de juegos',
  'fsBatch.roundsLabel': 'Rondas',
  'fsBatch.roundsRequired': 'Por favor ingrese rondas',
  'fsBatch.roundsPlaceholder': 'Rondas de giro gratis por miembro',
  'fsBatch.denomination': 'Denominación (opcional)',
  'fsBatch.denominationPlaceholder': 'Dejar en blanco para el valor predeterminado del juego',
  'fsBatch.startTime': 'Hora de inicio (opcional)',
  'fsBatch.startTimePlaceholder': 'Vacío = en vigor ahora',
  'fsBatch.endTime': 'Hora de fin',
  'fsBatch.endTimeRequired': 'Selecciona la hora de fin',
  'fsBatch.endTimePast': 'La hora de fin no puede ser anterior a ahora',
  'fsBatch.endBeforeStart': 'La hora de fin debe ser posterior a la hora de inicio',
  'fsBatch.endTimePlaceholder': 'Plazo de validez',
  'fsBatch.memberFile': 'Lista de miembros',
  'fsBatch.selectCsv': 'Seleccionar archivo CSV',
  'fsBatch.csvFormatHint': 'Formato CSV: fila de encabezado, luego una cuenta de miembro por línea',
  'fsBatch.downloadTemplate': 'Descargar plantilla',
  'fsBatch.remark': 'Observación (opcional)',
  'fsBatch.remarkPlaceholder': 'Propósito del envío',
  'fsBatch.uploadRequired': 'Carga el CSV de miembros',
  'fsBatch.fileSizeLimit': 'El archivo no puede exceder 30MB',
  'fsBatch.uploadFailed': 'Error al cargar el archivo',
  'fsBatch.submitFailed': 'Error al enviar',
  'fsBatch.submitSuccess': 'Envío enviado, número de lote: {{batchNo}}',
  'fsBatch.taskTitle': 'Detalles del envío',
  'fsBatch.memberId': 'Cuenta del miembro',
  'fsBatch.vendorUsername': 'Cuenta del proveedor',
  'fsBatch.currency': 'Moneda',
  'fsBatch.attempt': 'Reintentos',
  'fsBatch.vendorTxId': 'ID de Tx del proveedor',
  'fsBatch.errorCode': 'Código de error',
  'fsBatch.errorMsg': 'Mensaje de error',
  'fsBatch.taskStatus.0': 'Pendiente',
  'fsBatch.taskStatus.1': 'Procesando',
  'fsBatch.taskStatus.2': 'Éxito',
  'fsBatch.taskStatus.3': 'Fallido',
  'fsBatch.whitelistTab': 'Lista de juegos con giros gratis',
  'fsBatch.dispatchTab': 'Envío de giros gratis',
  'fsBatch.wlId': 'ID',
  'fsBatch.wlGameId': 'ID de juego',
  'fsBatch.wlGameName': 'Nombre del juego',
  'fsBatch.wlUpdateTime': 'Hora de actualización',
  'fsBatch.wlEnabled': 'Habilitado',
  'fsBatch.wlDisabled': 'Deshabilitado',
  'fsBatch.wlEnable': 'Habilitar',
  'fsBatch.wlDisable': 'Deshabilitar',
  'fsBatch.wlDelete': 'Eliminar',
  'fsBatch.wlAdd': 'Añadir',
  'fsBatch.wlAddTitle': 'Añadir juego a lista blanca',
  'fsBatch.wlGameIdRequired': 'Ingresa el ID del juego',
  'fsBatch.wlGameIdPlaceholder': 'game_id del lado del proveedor',
  'fsBatch.wlGameNamePlaceholder': 'Ingresa el nombre del juego',
  'fsBatch.wlDeleteConfirm': '¿Eliminar este juego?',
  'fsBatch.wlDeleteSuccess': 'Eliminado',
  'fsBatch.wlAddSuccess': 'Añadido',
  'fsBatch.wlOpSuccess': 'Operación exitosa',
  'fsBatch.wlOpFailed': 'Operación fallida',
  'chickActivity.continuousCheckin': 'Registro Consecutivo',
  'chickActivity.continuousCheckinDesc': 'Al desactivar: se oculta la entrada de registro consecutivo; los días acumulados se conservan y continúan al reactivar.',
  'chickActivity.continuousCheckinRule': 'Reglas (fijas): cuenta desde el primer día de registro; faltar un día reinicia al día 1; el día N otorga la recompensa del día N, y al completar un ciclo vuelve al día 1; máximo un registro por día. Las recompensas en efectivo requieren el múltiplo de apuestas antes de retirar (sin interruptor independiente).',
  'chickActivity.continuousTargetDay': 'Días Consecutivos Objetivo',
  'chickActivity.dayUnit': 'día(s)',
  'chickActivity.coupon': 'Ticket',
  'chickActivity.couponTemplate': 'Plantilla de Ticket',
  'chickActivity.selectCouponTemplate': 'Seleccionar plantilla',
  'chickActivity.depositCheckinV2': 'Registro por Depósito (Multidimensión · Multirecompensa)',
  'chickActivity.statMetric': 'Métrica',
  'chickActivity.byAmount': 'Por Monto',
  'chickActivity.byCount': 'Por Cantidad',
  'chickActivity.byAmountHint': 'Por monto: los niveles se asignan por el monto acumulado de depósitos.',
  'chickActivity.byCountHint': 'Por cantidad: los niveles se asignan por el número acumulado de depósitos; la base de recompensa sigue siendo el monto acumulado.',
  'chickActivity.cycleSpan': 'Duración del Ciclo',
  'chickActivity.rewardTypesMulti': 'Tipos de recompensa (selección múltiple, al menos uno)',
  'chickActivity.v2Formula': 'Efectivo/Puntos: total = depósito acumulado × "ratio total de {span} días" del nivel → dividido por la curva D1–D{span} (suma=100%); Ticket: por nivel "plantilla + cantidad total" → dividido por curva de cantidad (suma = total, enteros).',
  'chickActivity.v2FormulaNote': 'Montos truncados a 2 decimales; ratios con 1 decimal. Tope configurable solo en el nivel más alto (tickets sin tope). Subir de nivel reinicia la ronda desde el día 1 (sin doble registro el mismo día); tras completar una ronda, el siguiente depósito inicia una nueva.',
  'chickActivity.tierRangeTitle': 'Rangos de Nivel (compartidos por efectivo/puntos/tickets)',
  'chickActivity.depositAmountRange': 'Rango de Monto de Depósito',
  'chickActivity.depositCountRange': 'Rango de Cantidad de Depósitos',
  'chickActivity.amountUnit': 'monto',
  'chickActivity.countUnit': 'cantidad',
  'chickActivity.noUpperLimit': 'Sin límite (-1)',
  'chickActivity.depositAmount': 'monto de depósito',
  'chickActivity.depositCount': 'cantidad de depósitos',
  'chickActivity.tierRange': 'Nivel',
  'chickActivity.thresholdMin': 'Umbral (monto; se alcanza cuando el primer depósito del día >= umbral)',
  'chickActivity.baseCapCash': 'Tope de base de cálculo de efectivo (monto)',
  'chickActivity.baseCapPoints': 'Tope de base de cálculo de puntos (monto)',
  'chickActivity.baseCapHint': 'Base de premio = min(primer depósito del día, tope); no afecta la clasificación de nivel; vacío = sin tope. Ej.: depósito 1.000.000 con tope 10.000 se calcula con 10.000.',
  'chickActivity.dailyRatioCurveTitle': ' - Porcentaje diario según días consecutivos (%, aplicado al primer depósito del día; cada día independiente, sin requerir suma=100%)',
  'chickActivity.dailyRatioExample': 'Ejemplo: nivel D3 al 10%, primer depósito 150, ese nivel paga 150 x 10% = 15 ese día (los niveles se acumulan si se alcanzan varios).',
  'chickActivity.cycleSpanHintV3': 'Ciclo = máximo de días consecutivos por nivel: al superarlo el nivel vuelve a D1; cada nivel cuenta de forma independiente y fallar un umbral (o no firmar) reinicia solo ese nivel.',
  'chickActivity.v3Formula': 'Solo el primer depósito del día clasifica, una firma por día (liquida todos los niveles a la vez); cada nivel cuyo umbral se alcanza suma +1 y paga porcentaje x min(primer depósito, tope de base) acumulado entre niveles; los cupones se pagan por la curva del día de cada nivel.',
  'chickActivity.v3FormulaNote': 'No alcanzar un umbral (o no firmar ese día) reinicia la racha de ese nivel a D1; los demás niveles no se afectan. Montos truncados a 2 decimales; puntos truncados a entero.',
  'chickActivity.tierRangeTitleV3': 'Umbrales de nivel (compartidos por efectivo/puntos/cupones; mínimo >=1, estrictamente crecientes, acumulables)',
  'chickActivity.wagerMultipleHint': 'Apuesta requerida = premio del nivel x multiplicador (todos los juegos, sin plazo); 0/vacío = sin requisito',
  'chickActivity.couponCurveTitleV3': 'Curva de cupones (se paga según el día D de racha de cada nivel; el total es solo validación de configuración, al reiniciar se paga de nuevo desde D1, sin tope)',
  'chickActivity.v3FootNote': 'Agregar/eliminar niveles sincroniza todas las filas de tipos de premio habilitados; las monedas son independientes; el nombre del nivel es la clave del estado de racha - renombrar tras el lanzamiento reinicia sus rachas.',
  'chickActivity.totalRatioPercent': ' ratio total (%)',
  'chickActivity.highestTierCap': 'Tope del Nivel Más Alto',
  'chickActivity.onlyHighestTier': 'Solo nivel más alto',
  'chickActivity.curveTotal': 'Total',
  'chickActivity.splitCurveTitle': ' curva de división (suma=100%)',
  'chickActivity.couponCurveTitle': 'Curva de distribución de tickets (por cantidad, enteros, suma = total)',
  'chickActivity.couponTotalQty': 'Cantidad Total',
  'chickActivity.typeConfigSuffix': ' Configuración',
  'chickActivity.cashWagerEnable': 'Activar requisito de apuestas (completar antes de retirar)',
  'chickActivity.wagerBase': 'Base de apuestas',
  'chickActivity.wagerBaseReward': 'Solo recompensa',
  'chickActivity.wagerBaseRewardDeposit': 'Recompensa + depósito',
  'chickActivity.wagerScope': 'Alcance de apuestas',
  'chickActivity.wagerScopeAll': 'Todos los juegos',
  'chickActivity.wagerScopeSports': 'Solo deportes',
  'chickActivity.wagerScopeLive': 'Solo en vivo',
  'chickActivity.wagerScopeSlots': 'Solo slots',
  'chickActivity.wagerDeadline': 'Plazo de apuestas (días)',
  'chickActivity.wagerMultipleTimes': 'Múltiplo de apuestas (x)',
  'chickActivity.wagerNote': 'Nota',
  'chickActivity.wagerFormula': 'Apuestas requeridas = recompensa del nivel × múltiplo',
  'chickActivity.v2FootNote': 'Agregar/eliminar niveles sincroniza las filas de curva de todos los tipos activados; las monedas son independientes; cambiar métrica/ciclo/tipos no borra los valores ingresados.',
  'chickActivity.applyScope': 'Alcance de Marca de Juego',
  'chickActivity.allBrands': 'Todas las marcas',
  'chickActivity.allGamesOfBrand': 'Todos los juegos de la marca',
  'chickActivity.specificGames': 'Juegos específicos',
  'chickActivity.selectGamesPlaceholder': 'Buscar y seleccionar juegos',
  'chickActivity.scopeHint': 'Con "Juegos específicos", solo las apuestas de los juegos seleccionados cuentan para este hito; marca y juegos individuales son excluyentes.',
  'chickActivity.scopeInherit': 'Heredar predeterminado',
  'chickActivity.scopeOverride': 'Sobrescribir',
  'chickActivity.defaultScopeTitle': 'Alcance (predeterminado; los niveles nuevos lo heredan, sobrescribible por nivel)',
  'chickActivity.tierScopeTitle': 'Alcance de Marca del Nivel',
  'chickActivity.tierScopeHint': '"Heredar predeterminado" sigue el alcance del módulo; sobrescribir solo afecta este nivel.',
  'chickActivity.currentDefault': 'Predeterminado actual',
  'activity.chickActivity.report.continuousClaimCount': 'Reclamantes Registro Consecutivo',
  'activity.chickActivity.report.continuousCash': 'Efectivo Registro Consecutivo',
  'activity.chickActivity.report.continuousPoints': 'Puntos Registro Consecutivo',
  'activity.chickActivity.report.continuousCoupon': 'Tickets Registro Consecutivo',
  'activity.chickActivity.report.v2ClaimCount': 'Reclamantes Registro Depósito',
  'activity.chickActivity.report.v2Cash': 'Efectivo Registro Depósito',
  'activity.chickActivity.report.v2Points': 'Puntos Registro Depósito',
  'activity.chickActivity.report.v2Coupon': 'Tickets Registro Depósito',
  'chickActivity.allGamesLabel': 'Todos los juegos',
  'chickActivity.andMoreItems': 'y {n} elementos',
  'chickActivity.scopeTreeHint': 'Selección en tres niveles: Categoría → Plataforma → Juego; sin selección = todos los juegos',
  'chickActivity.pickGames': 'Elegir juegos',
  'chickActivity.collapseGames': 'Contraer',
  'chickActivity.selectedGamesCount': '{n} seleccionados',
  'chickActivity.noGames': 'Sin datos de juegos para esta plataforma',
  'chickActivity.editCopy': 'Editar Textos',
  'chickActivity.taskNameLabel': 'Nombre de la Tarea',
  'chickActivity.taskDescLabel': 'Descripción de la Tarea',
  'chickActivity.pickGamesHint': 'Marque juegos específicos; sin marcar = todos los juegos de esta plataforma',
  'chickActivity.searchGamePlaceholder': 'Buscar plataforma / nombre del juego',
};

